var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCulturalSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 166,
    viewBox: "0 0 195 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2761_32788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3934 99.4658H25.3672V100.939H29.3934V99.4658Z",
    fill: "#98C6CF",
    stroke: "url(#paint0_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1387 100.812H23.6226V102.286H31.1387V100.812Z",
    fill: "#98C6CF",
    stroke: "url(#paint1_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3016 102.488H22.46V103.962H32.3016V102.488Z",
    fill: "#98C6CF",
    stroke: "url(#paint2_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2701 103.855H21.4907V105.329H33.2701V103.855Z",
    fill: "#98C6CF",
    stroke: "url(#paint3_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1612 105.338H20.5991V106.811H34.1612V105.338Z",
    fill: "#98C6CF",
    stroke: "url(#paint4_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5632 108.053H18.1973V110.07H36.5632V108.053Z",
    fill: "#98C6CF",
    stroke: "url(#paint5_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5632 110.041H18.1973V112.058H36.5632V110.041Z",
    fill: "#98C6CF",
    stroke: "url(#paint6_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5632 112.035H18.1973V114.052H36.5632V112.035Z",
    fill: "#98C6CF",
    stroke: "url(#paint7_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5632 114.024H18.1973V116.041H36.5632V114.024Z",
    fill: "#98C6CF",
    stroke: "url(#paint8_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7286 97.218L27.4575 96.6898C27.4213 96.6544 27.3948 96.6498 27.3775 96.6534C27.3576 96.6498 27.327 96.6544 27.2857 96.6898L26.9743 97.218C26.9443 97.2693 26.9366 97.3334 26.954 97.3913C26.9738 97.4595 27.0253 97.5103 27.088 97.5241L27.3535 97.5816V97.5928L27.378 97.5867L27.4055 97.5928V97.58L27.6302 97.5246C27.6848 97.5113 27.7296 97.4605 27.747 97.3918C27.7617 97.3334 27.7551 97.2693 27.7286 97.218Z",
    fill: "#98C6CF",
    stroke: "url(#paint9_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6475 98.0677H27.0513C26.9371 98.0677 26.8393 97.9851 26.8194 97.8723C26.7919 97.7154 26.9116 97.5713 27.0701 97.5713H27.6287C27.7872 97.5713 27.907 97.7154 27.8794 97.8723C27.8596 97.9851 27.7622 98.0677 27.6475 98.0677Z",
    fill: "#98C6CF",
    stroke: "url(#paint10_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9009 98.3404H27.7984C27.7984 98.3404 27.648 98.0245 27.3274 98.0471C27.0064 98.0696 26.9009 98.3404 26.9009 98.3404Z",
    fill: "#98C6CF",
    stroke: "url(#paint11_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8682 98.3379C26.8682 98.3379 26.3972 98.6764 26.4869 98.7892C26.5766 98.902 26.8233 98.8794 26.8233 98.8794L26.7112 99.3533H28.0572L27.8553 98.8569C27.8553 98.8569 28.3935 98.8569 28.1693 98.6312C28.0454 98.5066 27.7656 98.3379 27.7656 98.3379H26.8682Z",
    fill: "#98C6CF",
    stroke: "url(#paint12_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6389 106.388L20.2607 105.652C20.2103 105.603 20.1736 105.596 20.1491 105.601C20.1211 105.596 20.0788 105.603 20.0212 105.652L19.5875 106.388C19.5457 106.46 19.535 106.549 19.559 106.63C19.587 106.725 19.6583 106.796 19.7455 106.814L20.1155 106.894V106.91L20.1491 106.902L20.1879 106.91V106.892L20.5008 106.815C20.5767 106.796 20.6389 106.726 20.6633 106.63C20.6848 106.549 20.6756 106.46 20.6389 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint13_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5261 107.571H19.6949C19.5359 107.571 19.3998 107.456 19.3718 107.298C19.3331 107.08 19.5002 106.879 19.7209 106.879H20.4996C20.7203 106.879 20.8875 107.08 20.8488 107.298C20.8217 107.456 20.6857 107.571 20.5261 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint14_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4854 107.946H20.7355C20.7355 107.946 20.526 107.506 20.0791 107.538C19.6326 107.569 19.4854 107.946 19.4854 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint15_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3073 106.388L23.9292 105.652C23.8787 105.603 23.842 105.596 23.8176 105.601C23.7901 105.596 23.7472 105.603 23.6897 105.652L23.256 106.388C23.2142 106.46 23.2035 106.549 23.2274 106.63C23.2554 106.725 23.3268 106.796 23.4139 106.814L23.7839 106.894V106.91L23.8176 106.902L23.8563 106.91V106.892L24.1692 106.815C24.2452 106.796 24.3073 106.726 24.3318 106.63C24.3532 106.549 24.344 106.46 24.3073 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint16_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1946 107.571H23.3634C23.2044 107.571 23.0678 107.456 23.0403 107.298C23.0015 107.08 23.1687 106.879 23.3899 106.879H24.1686C24.3893 106.879 24.5564 107.08 24.5182 107.298C24.4902 107.456 24.3541 107.571 24.1946 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint17_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1538 107.946H24.4045C24.4045 107.946 24.195 107.506 23.748 107.538C23.3011 107.569 23.1538 107.946 23.1538 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint18_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9758 106.388L27.5976 105.652C27.5472 105.603 27.51 105.596 27.486 105.601C27.4585 105.596 27.4157 105.603 27.3581 105.652L26.9244 106.388C26.8826 106.46 26.8719 106.549 26.8959 106.63C26.9239 106.725 26.9952 106.796 27.0824 106.814L27.4524 106.894V106.91L27.486 106.902L27.5248 106.91V106.892L27.8377 106.815C27.9136 106.796 27.9758 106.726 28.0003 106.63C28.0217 106.549 28.0125 106.46 27.9758 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint19_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8631 107.571H27.0318C26.8728 107.571 26.7368 107.456 26.7087 107.298C26.67 107.08 26.8372 106.879 27.0583 106.879H27.8371C28.0577 106.879 28.2249 107.08 28.1862 107.298C28.1587 107.456 28.0221 107.571 27.8631 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint20_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8223 107.946H28.0724C28.0724 107.946 27.863 107.506 27.416 107.538C26.9696 107.569 26.8223 107.946 26.8223 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint21_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9758 102.212L27.5976 101.476C27.5472 101.427 27.51 101.421 27.486 101.425C27.4585 101.42 27.4157 101.427 27.3581 101.476L26.9244 102.212C26.8826 102.284 26.8719 102.373 26.8959 102.454C26.9239 102.549 26.9952 102.62 27.0824 102.639L27.4524 102.719V102.735L27.486 102.726L27.5248 102.735V102.717L27.8377 102.639C27.9136 102.62 27.9758 102.55 28.0003 102.455C28.0217 102.373 28.0125 102.284 27.9758 102.212Z",
    fill: "#98C6CF",
    stroke: "url(#paint22_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8631 103.395H27.0318C26.8728 103.395 26.7368 103.28 26.7087 103.123C26.67 102.904 26.8372 102.703 27.0583 102.703H27.8371C28.0577 102.703 28.2249 102.904 28.1862 103.123C28.1587 103.28 28.0221 103.395 27.8631 103.395Z",
    fill: "#98C6CF",
    stroke: "url(#paint23_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8223 103.771H28.0724C28.0724 103.771 27.863 103.33 27.416 103.362C26.9696 103.393 26.8223 103.771 26.8223 103.771Z",
    fill: "#98C6CF",
    stroke: "url(#paint24_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6443 106.388L31.2661 105.652C31.2157 105.603 31.179 105.596 31.1545 105.601C31.127 105.596 31.0842 105.603 31.0266 105.652L30.5929 106.388C30.5511 106.46 30.5404 106.549 30.5643 106.63C30.5924 106.725 30.6637 106.796 30.7509 106.814L31.1209 106.894V106.91L31.1545 106.902L31.1932 106.91V106.892L31.5061 106.815C31.5821 106.796 31.6443 106.726 31.6687 106.63C31.6901 106.549 31.681 106.46 31.6443 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint25_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5315 107.571H30.7003C30.5413 107.571 30.4052 107.456 30.3772 107.298C30.3384 107.08 30.5056 106.879 30.7263 106.879H31.505C31.7257 106.879 31.8929 107.08 31.8546 107.298C31.8266 107.456 31.6905 107.571 31.5315 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint26_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4907 107.946H31.7409C31.7409 107.946 31.5314 107.506 31.0845 107.538C30.638 107.569 30.4907 107.946 30.4907 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint27_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3127 106.388L34.9346 105.652C34.8841 105.603 34.8469 105.596 34.8229 105.601C34.7954 105.596 34.7526 105.603 34.695 105.652L34.2613 106.388C34.2195 106.46 34.2088 106.549 34.2328 106.63C34.2608 106.725 34.3322 106.796 34.4193 106.814L34.7893 106.894V106.91L34.8229 106.902L34.8617 106.91V106.892L35.1746 106.815C35.2505 106.796 35.3127 106.726 35.3372 106.63C35.3586 106.549 35.3494 106.46 35.3127 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint28_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2 107.571H34.3688C34.2097 107.571 34.0732 107.456 34.0456 107.298C34.0069 107.08 34.1741 106.879 34.3953 106.879H35.174C35.3947 106.879 35.5618 107.08 35.5236 107.298C35.4951 107.456 35.359 107.571 35.2 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint29_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1592 107.946H35.4093C35.4093 107.946 35.1999 107.506 34.7529 107.538C34.3065 107.569 34.1592 107.946 34.1592 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint30_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1972 116.039L15.2407 118.365H39.703L36.3475 115.971L18.1972 116.039Z",
    fill: "#98C6CF",
    stroke: "url(#paint31_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5808 118.305H15.4238V119.287H39.5808V118.305Z",
    fill: "#98C6CF",
    stroke: "url(#paint32_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8784 119.37L18.6876 125.057V136.843H22.6226V124.965L23.9033 119.349L16.8784 119.37Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.8784 119.37L18.6876 125.057V136.843H22.6226V124.965L23.9033 119.349L16.8784 119.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8784 119.37L18.6876 125.057V136.843H22.6226V124.965L23.9033 119.349L16.8784 119.37Z",
    stroke: "url(#paint33_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3289 120.786H23.5756L23.9033 119.349L16.8784 119.37L17.3289 120.786Z",
    fill: "url(#paint34_linear_2761_32788)",
    stroke: "url(#paint35_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6083 136.721H20.6095H20.4871H18.577L17.9863 137.82V139.606H20.4871H20.6095H23.1714V137.82L22.6083 136.721Z",
    fill: "#98C6CF",
    stroke: "url(#paint36_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8949 139.419H20.6138H20.4746H18.2944L17.6201 140.518V142.304H20.4746H20.6138H23.5376V140.518L22.8949 139.419Z",
    fill: "#98C6CF",
    stroke: "url(#paint37_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6587 142.117H20.6254H20.4399H17.541L16.644 142.889V144.143H20.4399H20.6254H24.5134V142.889L23.6587 142.117Z",
    fill: "#98C6CF",
    stroke: "url(#paint38_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7017 119.37L33.5109 125.057V136.843H41.472V124.965L42.7532 119.349L31.7017 119.37Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.7017 119.37L33.5109 125.057V136.843H41.472V124.965L42.7532 119.349L31.7017 119.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7017 119.37L33.5109 125.057V136.843H41.472V124.965L42.7532 119.349L31.7017 119.37Z",
    stroke: "url(#paint39_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1527 120.786H42.425L42.7532 119.349L31.7017 119.37L32.1527 120.786Z",
    fill: "url(#paint40_linear_2761_32788)",
    stroke: "url(#paint41_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6481 136.721H37.3874H37.1881H34.0716L33.1079 137.82V139.606H37.1881H37.3874H41.5669V137.82L40.6481 136.721Z",
    fill: "#98C6CF",
    stroke: "url(#paint42_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1155 139.419H37.3941H37.1673H33.611L32.5112 140.518V142.304H37.1673H37.3941H42.1638V140.518L41.1155 139.419Z",
    fill: "#98C6CF",
    stroke: "url(#paint43_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3614 142.117H37.4128H37.1111H32.3811L30.9185 142.889V144.143H37.1111H37.4128H43.7558V142.889L42.3614 142.117Z",
    fill: "#98C6CF",
    stroke: "url(#paint44_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.622 100.933H169.648V99.4593H165.622V100.933Z",
    fill: "#98C6CF",
    stroke: "url(#paint45_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.878 102.284H171.394V100.811H163.878V102.284Z",
    fill: "#98C6CF",
    stroke: "url(#paint46_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.715 103.966H172.557V102.492H162.715V103.966Z",
    fill: "#98C6CF",
    stroke: "url(#paint47_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.746 105.328H173.525V103.855H161.746V105.328Z",
    fill: "#98C6CF",
    stroke: "url(#paint48_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.855 106.811H174.417V105.337H160.855V106.811Z",
    fill: "#98C6CF",
    stroke: "url(#paint49_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.453 110.067H176.819V108.05H158.453V110.067Z",
    fill: "#98C6CF",
    stroke: "url(#paint50_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.453 112.062H176.819V110.045H158.453V112.062Z",
    fill: "#98C6CF",
    stroke: "url(#paint51_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.453 114.056H176.819V112.039H158.453V114.056Z",
    fill: "#98C6CF",
    stroke: "url(#paint52_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.453 116.044H176.819V114.027H158.453V116.044Z",
    fill: "#98C6CF",
    stroke: "url(#paint53_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.288 97.218L167.559 96.6898C167.595 96.6544 167.621 96.6498 167.639 96.6534C167.659 96.6498 167.689 96.6544 167.73 96.6898L168.042 97.218C168.072 97.2693 168.08 97.3334 168.062 97.3913C168.042 97.4595 167.991 97.5103 167.928 97.5241L167.663 97.5816V97.5928L167.638 97.5867L167.61 97.5928V97.58L167.385 97.5246C167.331 97.5113 167.286 97.4605 167.269 97.3918C167.255 97.3334 167.262 97.2693 167.288 97.218Z",
    fill: "#98C6CF",
    stroke: "url(#paint54_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.369 98.0677H167.965C168.079 98.0677 168.177 97.9851 168.197 97.8723C168.224 97.7154 168.105 97.5713 167.946 97.5713H167.388C167.229 97.5713 167.109 97.7154 167.137 97.8723C167.157 97.9851 167.254 98.0677 167.369 98.0677Z",
    fill: "#98C6CF",
    stroke: "url(#paint55_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.116 98.3404H167.218C167.218 98.3404 167.369 98.0245 167.689 98.0471C168.01 98.0696 168.116 98.3404 168.116 98.3404Z",
    fill: "#98C6CF",
    stroke: "url(#paint56_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.148 98.3379C168.148 98.3379 168.619 98.6764 168.529 98.7892C168.44 98.902 168.193 98.8794 168.193 98.8794L168.305 99.3533H166.959L167.161 98.8569C167.161 98.8569 166.623 98.8569 166.847 98.6312C166.971 98.5066 167.251 98.3379 167.251 98.3379H168.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint57_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.377 106.388L174.755 105.652C174.806 105.603 174.842 105.596 174.867 105.601C174.894 105.596 174.937 105.603 174.995 105.652L175.429 106.388C175.47 106.46 175.481 106.549 175.457 106.63C175.429 106.725 175.358 106.796 175.271 106.814L174.901 106.894V106.91L174.867 106.902L174.828 106.91V106.892L174.515 106.815C174.439 106.796 174.377 106.726 174.353 106.63C174.331 106.549 174.34 106.46 174.377 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint58_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.49 107.571H175.321C175.48 107.571 175.616 107.456 175.644 107.298C175.683 107.08 175.516 106.879 175.295 106.879H174.516C174.296 106.879 174.128 107.08 174.167 107.298C174.195 107.456 174.331 107.571 174.49 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint59_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53 107.946H174.28C174.28 107.946 174.49 107.506 174.937 107.538C175.383 107.569 175.53 107.946 175.53 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint60_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.709 106.388L171.087 105.652C171.137 105.603 171.174 105.596 171.198 105.601C171.226 105.596 171.269 105.603 171.326 105.652L171.76 106.388C171.802 106.46 171.812 106.549 171.788 106.63C171.76 106.725 171.689 106.796 171.602 106.814L171.232 106.894V106.91L171.198 106.902L171.16 106.91V106.892L170.847 106.815C170.771 106.796 170.709 106.726 170.684 106.63C170.663 106.549 170.672 106.46 170.709 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint61_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.821 107.571H171.653C171.812 107.571 171.948 107.456 171.976 107.298C172.014 107.08 171.847 106.879 171.627 106.879H170.848C170.627 106.879 170.46 107.08 170.499 107.298C170.526 107.456 170.662 107.571 170.821 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint62_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.862 107.946H170.611C170.611 107.946 170.821 107.506 171.268 107.538C171.715 107.569 171.862 107.946 171.862 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint63_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.04 106.388L167.419 105.652C167.469 105.603 167.506 105.596 167.53 105.601C167.558 105.596 167.6 105.603 167.658 105.652L168.092 106.388C168.134 106.46 168.144 106.549 168.12 106.63C168.092 106.725 168.021 106.796 167.934 106.814L167.564 106.894V106.91L167.53 106.902L167.491 106.91V106.892L167.178 106.815C167.103 106.796 167.04 106.726 167.016 106.63C166.995 106.549 167.004 106.46 167.04 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint64_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.153 107.571H167.985C168.144 107.571 168.28 107.456 168.308 107.298C168.346 107.08 168.179 106.879 167.959 106.879H167.18C166.959 106.879 166.792 107.08 166.831 107.298C166.858 107.456 166.994 107.571 167.153 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint65_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 107.946H166.943C166.943 107.946 167.153 107.506 167.6 107.538C168.047 107.569 168.194 107.946 168.194 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint66_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.04 102.212L167.419 101.476C167.469 101.427 167.506 101.421 167.53 101.425C167.558 101.42 167.6 101.427 167.658 101.476L168.092 102.212C168.134 102.284 168.144 102.373 168.12 102.454C168.092 102.549 168.021 102.62 167.934 102.639L167.564 102.719V102.735L167.53 102.726L167.491 102.735V102.717L167.178 102.639C167.103 102.62 167.04 102.55 167.016 102.455C166.995 102.373 167.004 102.284 167.04 102.212Z",
    fill: "#98C6CF",
    stroke: "url(#paint67_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.153 103.395H167.985C168.144 103.395 168.28 103.28 168.308 103.123C168.346 102.904 168.179 102.703 167.959 102.703H167.18C166.959 102.703 166.792 102.904 166.831 103.123C166.858 103.28 166.994 103.395 167.153 103.395Z",
    fill: "#98C6CF",
    stroke: "url(#paint68_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 103.771H166.943C166.943 103.771 167.153 103.33 167.6 103.362C168.047 103.393 168.194 103.771 168.194 103.771Z",
    fill: "#98C6CF",
    stroke: "url(#paint69_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.372 106.388L163.75 105.652C163.801 105.603 163.838 105.596 163.862 105.601C163.89 105.596 163.932 105.603 163.99 105.652L164.424 106.388C164.465 106.46 164.476 106.549 164.452 106.63C164.424 106.725 164.353 106.796 164.266 106.814L163.896 106.894V106.91L163.862 106.902L163.823 106.91V106.892L163.51 106.815C163.434 106.796 163.372 106.726 163.348 106.63C163.326 106.549 163.336 106.46 163.372 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint70_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.485 107.571H164.316C164.475 107.571 164.611 107.456 164.639 107.298C164.678 107.08 164.51 106.879 164.289 106.879H163.51C163.29 106.879 163.123 107.08 163.161 107.298C163.189 107.456 163.325 107.571 163.485 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint71_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.526 107.946H163.275C163.275 107.946 163.485 107.506 163.932 107.538C164.378 107.569 164.526 107.946 164.526 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint72_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.704 106.388L160.082 105.652C160.132 105.603 160.169 105.596 160.193 105.601C160.221 105.596 160.264 105.603 160.321 105.652L160.755 106.388C160.797 106.46 160.807 106.549 160.783 106.63C160.755 106.725 160.684 106.796 160.597 106.814L160.227 106.894V106.91L160.193 106.902L160.154 106.91V106.892L159.842 106.815C159.766 106.796 159.703 106.726 159.679 106.63C159.658 106.549 159.667 106.46 159.704 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint73_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.816 107.571H160.648C160.807 107.571 160.943 107.456 160.971 107.298C161.01 107.08 160.842 106.879 160.622 106.879H159.843C159.622 106.879 159.455 107.08 159.494 107.298C159.521 107.456 159.657 107.571 159.816 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint74_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.857 107.946H159.607C159.607 107.946 159.816 107.506 160.263 107.538C160.71 107.569 160.857 107.946 160.857 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint75_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.819 116.039L179.775 118.365H155.313L158.668 115.971L176.819 116.039Z",
    fill: "#98C6CF",
    stroke: "url(#paint76_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.435 119.291H179.592V118.309H155.435V119.291Z",
    fill: "#98C6CF",
    stroke: "url(#paint77_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.138 119.37L176.328 125.057V136.843H172.394V124.965L171.113 119.349L178.138 119.37Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.138 119.37L176.328 125.057V136.843H172.394V124.965L171.113 119.349L178.138 119.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.138 119.37L176.328 125.057V136.843H172.394V124.965L171.113 119.349L178.138 119.37Z",
    stroke: "url(#paint78_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.441 120.786H177.687L178.138 119.37L171.113 119.349L171.441 120.786Z",
    fill: "url(#paint79_linear_2761_32788)",
    stroke: "url(#paint80_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.408 136.721H174.407H174.529H176.44L177.03 137.82V139.606H174.529H174.407H171.845V137.82L172.408 136.721Z",
    fill: "#98C6CF",
    stroke: "url(#paint81_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.122 139.419H174.403H174.542H176.722L177.396 140.518V142.304H174.542H174.403H171.479V140.518L172.122 139.419Z",
    fill: "#98C6CF",
    stroke: "url(#paint82_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.358 142.117H174.391H174.576H177.476L178.372 142.889V144.143H174.576H174.391H170.503V142.889L171.358 142.117Z",
    fill: "#98C6CF",
    stroke: "url(#paint83_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.314 119.37L161.505 125.057V136.843H153.544V124.965L152.263 119.349L163.314 119.37Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.314 119.37L161.505 125.057V136.843H153.544V124.965L152.263 119.349L163.314 119.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.314 119.37L161.505 125.057V136.843H153.544V124.965L152.263 119.349L163.314 119.37Z",
    stroke: "url(#paint84_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.864 120.786L163.314 119.37L152.263 119.349L152.591 120.786",
    fill: "url(#paint85_linear_2761_32788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.864 120.786L163.314 119.37L152.263 119.349L152.591 120.786",
    stroke: "url(#paint86_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.369 136.721H157.629H157.828H160.944L161.908 137.82V139.606H157.828H157.629H153.45V137.82L154.369 136.721Z",
    fill: "#98C6CF",
    stroke: "url(#paint87_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.901 139.419H157.622H157.85H161.406L162.506 140.518V142.304H157.85H157.622H152.853V140.518L153.901 139.419Z",
    fill: "#98C6CF",
    stroke: "url(#paint88_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.655 142.117H157.603H157.905H162.635L164.098 142.889V144.143H157.905H157.603H151.26V142.889L152.655 142.117Z",
    fill: "#98C6CF",
    stroke: "url(#paint89_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5889 141.981H62.9133",
    stroke: "url(#paint90_linear_2761_32788)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6694 142.357H48.3669",
    stroke: "url(#paint91_linear_2761_32788)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.733 92.5234H63.8262V96.8204H128.733V92.5234Z",
    fill: "#98C6CF",
    stroke: "url(#paint92_linear_2761_32788)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7641 78.6287C80.3951 74.9292 77.2919 72.041 73.5185 72.041C69.7446 72.041 66.6414 74.9292 66.2729 78.6287H80.7641Z",
    fill: "#98C6CF",
    stroke: "url(#paint93_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.531 78.6287C78.2757 74.9292 76.1291 72.041 73.5182 72.041C70.9073 72.041 68.7602 74.9292 68.5054 78.6287H78.531Z",
    fill: "#98C6CF",
    stroke: "url(#paint94_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0363 78.6287C75.9078 74.9292 74.8299 72.041 73.5181 72.041C72.2068 72.041 71.1284 74.9292 71.0005 78.6287H76.0363Z",
    fill: "#98C6CF",
    stroke: "url(#paint95_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7269 78.623H66.2725V80.5477H80.7269V78.623Z",
    fill: "#98C6CF",
    stroke: "url(#paint96_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5316 77.2974C66.4194 77.6799 66.3394 78.0759 66.291 78.4815H80.7276V78.3317C80.6777 77.9784 80.6038 77.6328 80.5054 77.2969L66.5316 77.2974Z",
    fill: "#98C6CF",
    stroke: "url(#paint97_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7269 80.4033H66.2725V81.5874H80.7269V80.4033Z",
    fill: "#98C6CF",
    stroke: "url(#paint98_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7273 84.2632H63.2466L66.2723 81.4365H80.7273V84.2632Z",
    fill: "#98C6CF",
    stroke: "url(#paint99_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2584 76.5039C67.9679 76.5039 67.7319 76.7408 67.7319 77.0336V78.348H68.7843V77.0336C68.7843 76.7408 68.5489 76.5039 68.2584 76.5039Z",
    fill: "#98C6CF",
    stroke: "url(#paint100_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3946 76.5039C78.1041 76.5039 77.8682 76.7408 77.8682 77.0336V78.348H78.9206V77.0336C78.9211 76.7408 78.6856 76.5039 78.3946 76.5039Z",
    fill: "#98C6CF",
    stroke: "url(#paint101_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0183 68.4774L73.5469 67.5589C73.4842 67.4979 73.4378 67.4897 73.4078 67.4958C73.3731 67.4897 73.3201 67.4979 73.2483 67.5589L72.7075 68.4774C72.655 68.5661 72.6423 68.6774 72.6719 68.7789C72.707 68.8979 72.7957 68.9861 72.9048 69.0092L73.366 69.1087V69.1282L73.4083 69.1179L73.4567 69.1282V69.1056L73.8471 69.0092C73.9419 68.9856 74.0193 68.8974 74.0499 68.7789C74.0754 68.6774 74.0642 68.5661 74.0183 68.4774Z",
    fill: "#98C6CF",
    stroke: "url(#paint102_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8783 69.949H72.8416C72.6434 69.949 72.4732 69.8059 72.4385 69.609C72.3906 69.3362 72.5991 69.0859 72.8743 69.0859H73.8456C74.1208 69.0859 74.3293 69.3362 74.2814 69.609C74.2467 69.8054 74.0765 69.949 73.8783 69.949Z",
    fill: "#98C6CF",
    stroke: "url(#paint103_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5801 70.4175H74.1396C74.1396 70.4175 73.8781 69.8683 73.3211 69.9073C72.7635 69.9467 72.5801 70.4175 72.5801 70.4175Z",
    fill: "#98C6CF",
    stroke: "url(#paint104_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5231 70.4229C72.5231 70.4229 71.7046 71.0116 71.8606 71.2075C72.0165 71.4039 72.4451 71.3644 72.4451 71.3644L72.2505 72.188H74.5897L74.2391 71.3249C74.2391 71.3249 75.1748 71.3249 74.7849 70.9326C74.5693 70.7162 74.0831 70.4229 74.0831 70.4229H72.5231Z",
    fill: "#98C6CF",
    stroke: "url(#paint105_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3462 72.1914V78.5468",
    stroke: "url(#paint106_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2466 84.2708L65.9915 87.9487V96.88H68.4622V87.8564L70.8413 84.2656L63.2466 84.2708Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.2466 84.2708L65.9915 87.9487V96.88H68.4622V87.8564L70.8413 84.2656L63.2466 84.2708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2466 84.2708L65.9915 87.9487V96.88H68.4622V87.8564L70.8413 84.2656L63.2466 84.2708Z",
    stroke: "url(#paint107_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3071 85.6918H69.8964L70.8413 84.2656L63.2466 84.2708L64.3071 85.6918Z",
    fill: "url(#paint108_linear_2761_32788)",
    stroke: "url(#paint109_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6978 84.2708L79.4427 87.9487V96.88H81.9134V87.8564L84.2924 84.2656L76.6978 84.2708Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.6978 84.2708L79.4427 87.9487V96.88H81.9134V87.8564L84.2924 84.2656L76.6978 84.2708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6978 84.2708L79.4427 87.9487V96.88H81.9134V87.8564L84.2924 84.2656L76.6978 84.2708Z",
    stroke: "url(#paint110_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7583 85.6918H83.3476L84.2924 84.2656L76.6978 84.2708L77.7583 85.6918Z",
    fill: "url(#paint111_linear_2761_32788)",
    stroke: "url(#paint112_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.716 92.0729C158.003 86.2667 152.007 81.7334 144.716 81.7334C137.424 81.7334 131.428 86.2667 130.715 92.0729H158.716Z",
    fill: "#98C6CF",
    stroke: "url(#paint113_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.401 92.0729C153.908 86.2667 149.76 81.7334 144.715 81.7334C139.671 81.7334 135.522 86.2667 135.029 92.0729H154.401Z",
    fill: "#98C6CF",
    stroke: "url(#paint114_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58 92.0729C149.332 86.2667 147.249 81.7334 144.715 81.7334C142.181 81.7334 140.098 86.2667 139.85 92.0729H149.58Z",
    fill: "#98C6CF",
    stroke: "url(#paint115_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.645 92.0791H130.715V95.0996H158.645V92.0791Z",
    fill: "#98C6CF",
    stroke: "url(#paint116_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.445 74.4915L144.705 73.0499C144.607 72.954 144.534 72.9412 144.487 72.951C144.432 72.9412 144.349 72.954 144.236 73.0499L143.387 74.4915C143.305 74.631 143.284 74.8053 143.331 74.9643C143.386 75.151 143.526 75.2894 143.697 75.3258L144.42 75.4817V75.5125L144.487 75.4961L144.563 75.5125V75.4776L145.175 75.3258C145.324 75.2889 145.446 75.1505 145.494 74.9643C145.534 74.8053 145.517 74.6305 145.445 74.4915Z",
    fill: "#98C6CF",
    stroke: "url(#paint117_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.224 76.8026H143.597C143.286 76.8026 143.019 76.578 142.965 76.2693C142.89 75.8411 143.217 75.4482 143.649 75.4482H145.173C145.605 75.4482 145.933 75.8411 145.857 76.2693C145.803 76.5775 145.536 76.8026 145.224 76.8026Z",
    fill: "#98C6CF",
    stroke: "url(#paint118_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.187 77.5468H145.634C145.634 77.5468 145.224 76.6848 144.35 76.7463C143.475 76.8084 143.187 77.5468 143.187 77.5468Z",
    fill: "#98C6CF",
    stroke: "url(#paint119_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.098 77.542C143.098 77.542 141.813 79.0728 142.057 79.381C142.302 79.6887 142.975 79.6271 142.975 79.6271L142.669 80.3128H146.341L145.79 79.5656C145.79 79.5656 147.015 79.7379 146.647 78.9497C146.225 78.0471 145.545 77.542 145.545 77.542H143.098Z",
    fill: "#98C6CF",
    stroke: "url(#paint120_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.382 81.9785V91.9529",
    stroke: "url(#paint121_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67 80.3184C142.67 80.3184 139.408 81.5045 138.951 82.6097H150.937C150.937 82.6097 149.247 81.0655 146.34 80.3184H142.67Z",
    fill: "#98C6CF",
    stroke: "url(#paint122_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.467 95.2217H126.476V96.695H162.467V95.2217Z",
    fill: "#98C6CF",
    stroke: "url(#paint123_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.491 90.6807C132.851 90.6807 132.332 91.2027 132.332 91.8468V95.2227H134.65V91.8468C134.65 91.2032 134.131 90.6807 133.491 90.6807Z",
    fill: "#98C6CF",
    stroke: "url(#paint124_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.227 90.6807C143.587 90.6807 143.068 91.2027 143.068 91.8468V95.2227H145.386V91.8468C145.386 91.2032 144.867 90.6807 144.227 90.6807Z",
    fill: "#98C6CF",
    stroke: "url(#paint125_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.329 90.6807C154.689 90.6807 154.17 91.2027 154.17 91.8468V95.2227H156.488V91.8468C156.489 91.2032 155.969 90.6807 155.329 90.6807Z",
    fill: "#98C6CF",
    stroke: "url(#paint126_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.392 78.6287C114.761 74.9292 117.864 72.041 121.637 72.041C125.411 72.041 128.514 74.9292 128.883 78.6287H114.392Z",
    fill: "#98C6CF",
    stroke: "url(#paint127_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.624 78.6287C116.879 74.9292 119.026 72.041 121.637 72.041C124.248 72.041 126.395 74.9292 126.65 78.6287H116.624Z",
    fill: "#98C6CF",
    stroke: "url(#paint128_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.119 78.6287C119.248 74.9292 120.325 72.041 121.637 72.041C122.949 72.041 124.027 74.9292 124.155 78.6287H119.119Z",
    fill: "#98C6CF",
    stroke: "url(#paint129_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.428 80.5488H128.883V78.6242H114.428V80.5488Z",
    fill: "#98C6CF",
    stroke: "url(#paint130_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.624 77.2974C128.736 77.6799 128.816 78.0759 128.864 78.4815H114.428V78.3317C114.478 77.9784 114.552 77.6328 114.65 77.2969L128.624 77.2974Z",
    fill: "#98C6CF",
    stroke: "url(#paint131_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.428 81.5928H128.883V80.4087H114.428V81.5928Z",
    fill: "#98C6CF",
    stroke: "url(#paint132_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.428 84.2632H131.909L128.883 81.4365H114.428V84.2632Z",
    fill: "#98C6CF",
    stroke: "url(#paint133_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.897 76.5039C127.188 76.5039 127.424 76.7408 127.424 77.0336V78.348H126.371V77.0336C126.371 76.7408 126.606 76.5039 126.897 76.5039Z",
    fill: "#98C6CF",
    stroke: "url(#paint134_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.76 76.5039C117.051 76.5039 117.287 76.7408 117.287 77.0336V78.348H116.234V77.0336C116.234 76.7408 116.47 76.5039 116.76 76.5039Z",
    fill: "#98C6CF",
    stroke: "url(#paint135_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.137 68.4774L121.608 67.5589C121.671 67.4979 121.717 67.4897 121.747 67.4958C121.782 67.4897 121.835 67.4979 121.907 67.5589L122.447 68.4774C122.5 68.5661 122.513 68.6774 122.483 68.7789C122.448 68.8979 122.359 68.9861 122.25 69.0092L121.789 69.1087V69.1282L121.747 69.1179L121.698 69.1282V69.1056L121.308 69.0092C121.213 68.9856 121.136 68.8974 121.105 68.7789C121.08 68.6774 121.091 68.5661 121.137 68.4774Z",
    fill: "#98C6CF",
    stroke: "url(#paint136_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.278 69.949H122.314C122.513 69.949 122.683 69.8059 122.717 69.609C122.766 69.3362 122.557 69.0859 122.282 69.0859H121.31C121.035 69.0859 120.827 69.3362 120.875 69.609C120.909 69.8054 121.079 69.949 121.278 69.949Z",
    fill: "#98C6CF",
    stroke: "url(#paint137_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.576 70.4175H121.016C121.016 70.4175 121.278 69.8683 121.835 69.9073C122.392 69.9467 122.576 70.4175 122.576 70.4175Z",
    fill: "#98C6CF",
    stroke: "url(#paint138_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.633 70.4229C122.633 70.4229 123.451 71.0116 123.296 71.2075C123.14 71.4039 122.711 71.3644 122.711 71.3644L122.906 72.188H120.567L120.918 71.3249C120.918 71.3249 119.982 71.3249 120.372 70.9326C120.587 70.7162 121.074 70.4229 121.074 70.4229H122.633Z",
    fill: "#98C6CF",
    stroke: "url(#paint139_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81 72.1914V78.5468",
    stroke: "url(#paint140_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.909 84.2708L129.164 87.9487V96.88H126.693V87.8564L124.314 84.2656L131.909 84.2708Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.909 84.2708L129.164 87.9487V96.88H126.693V87.8564L124.314 84.2656L131.909 84.2708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.909 84.2708L129.164 87.9487V96.88H126.693V87.8564L124.314 84.2656L131.909 84.2708Z",
    stroke: "url(#paint141_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.259 85.6918H130.849L131.909 84.2708L124.314 84.2656L125.259 85.6918Z",
    fill: "url(#paint142_linear_2761_32788)",
    stroke: "url(#paint143_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.458 84.2708L115.713 87.9487V96.88H113.242V87.8564L110.863 84.2656L118.458 84.2708Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.458 84.2708L115.713 87.9487V96.88H113.242V87.8564L110.863 84.2656L118.458 84.2708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.458 84.2708L115.713 87.9487V96.88H113.242V87.8564L110.863 84.2656L118.458 84.2708Z",
    stroke: "url(#paint144_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.808 85.6918H117.397L118.458 84.2708L110.863 84.2656L111.808 85.6918Z",
    fill: "url(#paint145_linear_2761_32788)",
    stroke: "url(#paint146_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7101 92.0729C63.9977 86.2667 58.0017 81.7334 50.7103 81.7334C43.4189 81.7334 37.4229 86.2667 36.7104 92.0729H64.7101Z",
    fill: "#98C6CF",
    stroke: "url(#paint147_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3959 92.0729C59.9031 86.2667 55.7546 81.7334 50.7097 81.7334C45.6652 81.7334 41.5167 86.2667 41.0239 92.0729H60.3959Z",
    fill: "#98C6CF",
    stroke: "url(#paint148_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5753 92.0729C55.3276 86.2667 53.2442 81.7334 50.7103 81.7334C48.1763 81.7334 46.0929 86.2667 45.8452 92.0729H55.5753Z",
    fill: "#98C6CF",
    stroke: "url(#paint149_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6388 92.0791H36.71V95.0996H64.6388V92.0791Z",
    fill: "#98C6CF",
    stroke: "url(#paint150_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4398 74.4915L50.6998 73.0499C50.6015 72.954 50.5286 72.9412 50.4817 72.951C50.4272 72.9412 50.3441 72.954 50.231 73.0499L49.3824 74.4915C49.3004 74.631 49.2795 74.8053 49.3264 74.9643C49.3814 75.151 49.521 75.2894 49.6918 75.3258L50.4155 75.4817V75.5125L50.4817 75.4961L50.5577 75.5125V75.4776L51.1702 75.3258C51.3191 75.2889 51.4409 75.1505 51.4888 74.9643C51.5295 74.8053 51.5112 74.6305 51.4398 74.4915Z",
    fill: "#98C6CF",
    stroke: "url(#paint151_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2193 76.8026H49.5925C49.2812 76.8026 49.0146 76.578 48.9601 76.2693C48.8846 75.8411 49.2118 75.4482 49.644 75.4482H51.1684C51.6005 75.4482 51.9277 75.8411 51.8523 76.2693C51.7978 76.5775 51.5307 76.8026 51.2193 76.8026Z",
    fill: "#98C6CF",
    stroke: "url(#paint152_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1826 77.5468H51.6304C51.6304 77.5468 51.2202 76.6848 50.3456 76.7463C49.4706 76.8084 49.1826 77.5468 49.1826 77.5468Z",
    fill: "#98C6CF",
    stroke: "url(#paint153_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0926 77.542C49.0926 77.542 47.8078 79.0728 48.0525 79.381C48.2971 79.6887 48.9703 79.6271 48.9703 79.6271L48.6645 80.3128H52.336L51.7856 79.5656C51.7856 79.5656 53.0102 79.7379 52.6423 78.9497C52.2208 78.0471 51.541 77.542 51.541 77.542H49.0926Z",
    fill: "#98C6CF",
    stroke: "url(#paint154_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3774 81.9785V91.9529",
    stroke: "url(#paint155_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6647 80.3184C48.6647 80.3184 45.4035 81.5045 44.9458 82.6097H56.9326C56.9326 82.6097 55.2426 81.0655 52.3356 80.3184H48.6647Z",
    fill: "#98C6CF",
    stroke: "url(#paint156_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0214 95.2217H32.4702V96.695H66.0214V95.2217Z",
    fill: "#98C6CF",
    stroke: "url(#paint157_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4856 90.6807C38.8455 90.6807 38.3267 91.2027 38.3267 91.8468V95.2227H40.645V91.8468C40.6445 91.2032 40.1257 90.6807 39.4856 90.6807Z",
    fill: "#98C6CF",
    stroke: "url(#paint158_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2219 90.6807C49.5818 90.6807 49.063 91.2027 49.063 91.8468V95.2227H51.3813V91.8468C51.3813 91.2032 50.862 90.6807 50.2219 90.6807Z",
    fill: "#98C6CF",
    stroke: "url(#paint159_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3245 90.6807C60.6843 90.6807 60.1655 91.2027 60.1655 91.8468V95.2227H62.4834V91.8468C62.4834 91.2032 61.9646 90.6807 61.3245 90.6807Z",
    fill: "#98C6CF",
    stroke: "url(#paint160_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1699 93.625C69.9003 93.625 69.6816 93.845 69.6816 94.1163V95.8353H70.6576V94.1163C70.6581 93.845 70.4395 93.625 70.1699 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint161_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1225 93.625C71.8529 93.625 71.6343 93.845 71.6343 94.1163V95.8353H72.6102V94.1163C72.6102 93.845 72.3916 93.625 72.1225 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint162_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0742 93.625C73.8046 93.625 73.5859 93.845 73.5859 94.1163V95.8353H74.5619V94.1163C74.5619 93.845 74.3438 93.625 74.0742 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint163_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0263 93.625C75.7567 93.625 75.5386 93.845 75.5386 94.1163V95.8353H76.5145V94.1163C76.5145 93.845 76.2959 93.625 76.0263 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint164_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.978 93.625C77.7084 93.625 77.4897 93.845 77.4897 94.1163V95.8353H78.4657V94.1163C78.4662 93.845 78.2476 93.625 77.978 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint165_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.142 93.625C116.872 93.625 116.654 93.845 116.654 94.1163V95.8353H117.63V94.1163C117.63 93.845 117.412 93.625 117.142 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint166_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.094 93.625C118.825 93.625 118.606 93.845 118.606 94.1163V95.8353H119.582V94.1163C119.582 93.845 119.364 93.625 119.094 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint167_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.046 93.625C120.777 93.625 120.558 93.845 120.558 94.1163V95.8353H121.534V94.1163C121.534 93.845 121.316 93.625 121.046 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint168_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.998 93.625C122.729 93.625 122.51 93.845 122.51 94.1163V95.8353H123.486V94.1163C123.487 93.845 123.268 93.625 122.998 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint169_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.95 93.625C124.681 93.625 124.462 93.845 124.462 94.1163V95.8353H125.438V94.1163C125.438 93.845 125.22 93.625 124.95 93.625Z",
    fill: "#98C6CF",
    stroke: "url(#paint170_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0244 99.0947L32.5929 103.453V113.52H40.2793H69.4996V105.662H77.0026V113.765H117.882V105.84H125.376V113.765H162.772V103.33L165.639 99.0947H29.0244Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.0244 99.0947L32.5929 103.453V113.52H40.2793H69.4996V105.662H77.0026V113.765H117.882V105.84H125.376V113.765H162.772V103.33L165.639 99.0947H29.0244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0244 99.0947L32.5929 103.453V113.52H40.2793H69.4996V105.662H77.0026V113.765H117.882V105.84H125.376V113.765H162.772V103.33L165.639 99.0947H29.0244Z",
    stroke: "url(#paint171_linear_2761_32788)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1729 99.0947L48.059 102.24V113.52H69.4996V105.662H77.0025V113.565H117.882V105.84H125.376V113.565H149.623V103.898L154.396 99.0947H45.1729Z",
    fill: "#98C6CF",
    stroke: "url(#paint172_linear_2761_32788)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8268 118.961H39.167V144.748H78.8268V118.961Z",
    fill: "#98C6CF",
    stroke: "url(#paint173_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7711 119.655H38.5708V121.865H50.7711V119.655Z",
    fill: "#98C6CF",
    stroke: "url(#paint174_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3032 121.848V140.404L37.229 143.227V144.701H52.1136V143.105L50.1617 139.912V121.796L39.3032 121.848Z",
    fill: "#98C6CF",
    stroke: "url(#paint175_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.207 120.517V140.405",
    stroke: "url(#paint176_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7215 136.843L46.8673 136.291L46.0132 136.843V139.299H47.7215V136.843Z",
    fill: "#98C6CF",
    stroke: "url(#paint177_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5577 119.655H52.3574V121.865H64.5577V119.655Z",
    fill: "#98C6CF",
    stroke: "url(#paint178_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0894 121.848V140.404L51.0151 143.227V144.701H65.9002V143.105L63.9478 139.912V121.796L53.0894 121.848Z",
    fill: "#98C6CF",
    stroke: "url(#paint179_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9937 120.517V140.405",
    stroke: "url(#paint180_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5076 136.843L60.654 136.291L59.7998 136.843V139.299H61.5076V136.843Z",
    fill: "#98C6CF",
    stroke: "url(#paint181_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9619 140.227H62.6646",
    stroke: "url(#paint182_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2915 141.35H48.8646",
    stroke: "url(#paint183_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2915 135.456H76.6976",
    stroke: "url(#paint184_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2915 134.167H76.6976",
    stroke: "url(#paint185_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2915 132.883H76.6976",
    stroke: "url(#paint186_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5132 120.084V140.351",
    stroke: "url(#paint187_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0976 124.959H70.8706V129.963H75.0976V124.959Z",
    stroke: "url(#paint188_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1244 124.839H69.2539V126.966H70.1244V124.839Z",
    stroke: "url(#paint189_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7132 124.839H75.8428V126.966H76.7132V124.839Z",
    stroke: "url(#paint190_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7132 128.467H75.8428V130.593H76.7132V128.467Z",
    stroke: "url(#paint191_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1244 128.842H69.2539V130.968H70.1244V128.842Z",
    stroke: "url(#paint192_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9173 124.959H58.9736V129.963H61.9173V124.959Z",
    stroke: "url(#paint193_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4536 124.839H57.8477V126.966H58.4536V124.839Z",
    stroke: "url(#paint194_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0425 124.839H62.4365V126.966H63.0425V124.839Z",
    stroke: "url(#paint195_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0425 128.467H62.4365V130.593H63.0425V128.467Z",
    stroke: "url(#paint196_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4536 128.842H57.8477V130.968H58.4536V128.842Z",
    stroke: "url(#paint197_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3873 124.959H45.1694V129.963H48.3873V124.959Z",
    stroke: "url(#paint198_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.602 124.839H43.9395V126.966H44.602V124.839Z",
    stroke: "url(#paint199_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6176 124.839H48.9551V126.966H49.6176V124.839Z",
    stroke: "url(#paint200_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6176 128.467H48.9551V130.593H49.6176V128.467Z",
    stroke: "url(#paint201_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.602 128.842H43.9395V130.968H44.602V128.842Z",
    stroke: "url(#paint202_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3933 125.262H51.0249V129.9H52.3933V125.262Z",
    stroke: "url(#paint203_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6877 125.262H54.3193V129.9H55.6877V125.262Z",
    stroke: "url(#paint204_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9621 125.262H40.5938V129.9H41.9621V125.262Z",
    stroke: "url(#paint205_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3645 125.262H64.9961V129.9H66.3645V125.262Z",
    stroke: "url(#paint206_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3017 101.459H58.1792V102.968H62.3017V101.459Z",
    fill: "#98C6CF",
    stroke: "url(#paint207_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0887 102.848H56.3926V104.356H64.0887V102.848Z",
    fill: "#98C6CF",
    stroke: "url(#paint208_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2798 104.56H55.2021V106.068H65.2798V104.56Z",
    fill: "#98C6CF",
    stroke: "url(#paint209_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2716 105.953H54.21V107.462H66.2716V105.953Z",
    fill: "#98C6CF",
    stroke: "url(#paint210_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1841 107.478H53.2969V108.986H67.1841V107.478Z",
    fill: "#98C6CF",
    stroke: "url(#paint211_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5974 99.162L60.3196 98.6209C60.2824 98.585 60.2554 98.5804 60.2376 98.584C60.2172 98.5804 60.1861 98.585 60.1433 98.6209L59.8248 99.162C59.7937 99.2143 59.7861 99.2799 59.8039 99.3394C59.8243 99.4097 59.8768 99.4615 59.941 99.4753L60.2126 99.5338V99.545L60.2376 99.5389L60.2661 99.545V99.5317L60.496 99.4748C60.552 99.4609 60.5974 99.4091 60.6157 99.3389C60.631 99.2799 60.6244 99.2143 60.5974 99.162Z",
    fill: "#98C6CF",
    stroke: "url(#paint212_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5148 100.031H59.9042C59.787 100.031 59.6871 99.9466 59.6667 99.8307C59.6382 99.6702 59.761 99.5225 59.9236 99.5225H60.4959C60.658 99.5225 60.7808 99.6702 60.7528 99.8307C60.7319 99.9471 60.6315 100.031 60.5148 100.031Z",
    fill: "#98C6CF",
    stroke: "url(#paint213_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7495 100.31H60.6684C60.6684 100.31 60.5145 99.9859 60.1858 100.009C59.8581 100.032 59.7495 100.31 59.7495 100.31Z",
    fill: "#98C6CF",
    stroke: "url(#paint214_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7161 100.311C59.7161 100.311 59.2334 100.657 59.3257 100.773C59.4174 100.888 59.6702 100.865 59.6702 100.865L59.5555 101.351H60.9336L60.7267 100.842C60.7267 100.842 61.2781 100.842 61.0483 100.611C60.9214 100.483 60.635 100.311 60.635 100.311H59.7161Z",
    fill: "#98C6CF",
    stroke: "url(#paint215_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.338 108.551L52.9512 107.797C52.8997 107.747 52.8615 107.74 52.837 107.746C52.8085 107.74 52.7652 107.747 52.7061 107.797L52.2622 108.551C52.2193 108.624 52.2086 108.715 52.2331 108.798C52.2616 108.896 52.335 108.968 52.4242 108.988L52.8029 109.069V109.085L52.8375 109.076L52.8773 109.085V109.067L53.1979 108.987C53.2758 108.968 53.3395 108.895 53.3645 108.798C53.3849 108.716 53.3757 108.625 53.338 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint216_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2228 109.763H52.3717C52.2086 109.763 52.0695 109.646 52.0409 109.484C52.0012 109.26 52.1724 109.055 52.3987 109.055H53.1963C53.4226 109.055 53.5933 109.26 53.554 109.484C53.525 109.646 53.3859 109.763 53.2228 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint217_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1572 110.148H53.4374C53.4374 110.148 53.2229 109.697 52.7652 109.729C52.3081 109.761 52.1572 110.148 52.1572 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint218_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0944 108.551L56.7075 107.797C56.6561 107.747 56.6178 107.74 56.5934 107.746C56.5648 107.74 56.5215 107.747 56.4624 107.797L56.0185 108.551C55.9757 108.624 55.965 108.715 55.9895 108.798C56.018 108.896 56.0914 108.968 56.1806 108.988L56.5592 109.069V109.085L56.5939 109.076L56.6336 109.085V109.067L56.9542 108.987C57.0322 108.968 57.0959 108.895 57.1209 108.798C57.1412 108.716 57.1316 108.625 57.0944 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint219_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9786 109.763H56.1275C55.9644 109.763 55.8253 109.646 55.7968 109.484C55.757 109.26 55.9283 109.055 56.1545 109.055H56.9521C57.1784 109.055 57.3496 109.26 57.3099 109.484C57.2814 109.646 57.1417 109.763 56.9786 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint220_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9131 110.148H57.1933C57.1933 110.148 56.9787 109.697 56.5211 109.729C56.0634 109.762 55.9131 110.148 55.9131 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint221_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8507 108.551L60.4639 107.797C60.4124 107.747 60.3742 107.74 60.3497 107.746C60.3212 107.74 60.2779 107.747 60.2188 107.797L59.7749 108.551C59.732 108.624 59.7213 108.715 59.7458 108.798C59.7743 108.896 59.8477 108.968 59.9369 108.988L60.3156 109.069V109.085L60.3502 109.076L60.39 109.085V109.067L60.7106 108.987C60.7885 108.968 60.8522 108.895 60.8772 108.798C60.8976 108.716 60.8884 108.625 60.8507 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint222_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7355 109.763H59.8844C59.7213 109.763 59.5821 109.646 59.5536 109.484C59.5139 109.26 59.6851 109.055 59.9114 109.055H60.7085C60.9347 109.055 61.1055 109.26 61.0662 109.484C61.0377 109.646 60.898 109.763 60.7355 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint223_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6699 110.148H60.9501C60.9501 110.148 60.7356 109.697 60.2779 109.729C59.8203 109.761 59.6699 110.148 59.6699 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint224_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8507 104.276L60.4639 103.522C60.4124 103.472 60.3742 103.465 60.3497 103.47C60.3212 103.465 60.2779 103.472 60.2188 103.522L59.7749 104.276C59.732 104.349 59.7213 104.44 59.7458 104.523C59.7743 104.62 59.8477 104.693 59.9369 104.712L60.3156 104.794V104.81L60.3502 104.801L60.39 104.81V104.791L60.7106 104.712C60.7885 104.692 60.8522 104.62 60.8772 104.523C60.8976 104.44 60.8884 104.349 60.8507 104.276Z",
    fill: "#98C6CF",
    stroke: "url(#paint225_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7355 105.488H59.8844C59.7213 105.488 59.5821 105.371 59.5536 105.209C59.5139 104.985 59.6851 104.779 59.9114 104.779H60.7085C60.9347 104.779 61.1055 104.985 61.0662 105.209C61.0377 105.37 60.898 105.488 60.7355 105.488Z",
    fill: "#98C6CF",
    stroke: "url(#paint226_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6699 105.872H60.9501C60.9501 105.872 60.7356 105.421 60.2779 105.454C59.8203 105.486 59.6699 105.872 59.6699 105.872Z",
    fill: "#98C6CF",
    stroke: "url(#paint227_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6071 108.551L64.2202 107.797C64.1688 107.747 64.1305 107.74 64.1061 107.746C64.0775 107.74 64.0342 107.747 63.9751 107.797L63.5312 108.551C63.4884 108.624 63.4777 108.715 63.5022 108.798C63.5307 108.896 63.6041 108.968 63.6933 108.988L64.0719 109.069V109.085L64.1066 109.076L64.1463 109.085V109.067L64.4669 108.987C64.5449 108.968 64.6086 108.895 64.6336 108.798C64.6539 108.716 64.6443 108.625 64.6071 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint228_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4913 109.763H63.6402C63.4771 109.763 63.3375 109.646 63.3095 109.484C63.2697 109.26 63.441 109.055 63.6672 109.055H64.4648C64.6911 109.055 64.8618 109.26 64.8226 109.484C64.794 109.646 64.6544 109.763 64.4913 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint229_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4258 110.148H64.706C64.706 110.148 64.4914 109.697 64.0338 109.729C63.5766 109.761 63.4258 110.148 63.4258 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint230_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3636 108.551L67.9768 107.797C67.9253 107.747 67.8871 107.74 67.8627 107.746C67.8341 107.74 67.7908 107.747 67.7317 107.797L67.2878 108.551C67.245 108.624 67.2338 108.715 67.2587 108.798C67.2873 108.896 67.3607 108.968 67.4498 108.988L67.8285 109.069V109.085L67.8632 109.076L67.9029 109.085V109.067L68.2235 108.987C68.3014 108.968 68.3652 108.895 68.3901 108.798C68.4105 108.716 68.4008 108.625 68.3636 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint231_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2482 109.763H67.3971C67.234 109.763 67.0948 109.646 67.0663 109.484C67.0265 109.26 67.1978 109.055 67.4241 109.055H68.2217C68.4479 109.055 68.6192 109.26 68.5794 109.484C68.5504 109.646 68.4107 109.763 68.2482 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint232_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1826 110.148H68.4628C68.4628 110.148 68.2483 109.697 67.7906 109.729C67.333 109.762 67.1826 110.148 67.1826 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint233_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9018 101.459H44.7793V102.968H48.9018V101.459Z",
    fill: "#98C6CF",
    stroke: "url(#paint234_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6888 102.848H42.9927V104.356H50.6888V102.848Z",
    fill: "#98C6CF",
    stroke: "url(#paint235_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8799 104.56H41.8022V106.068H51.8799V104.56Z",
    fill: "#98C6CF",
    stroke: "url(#paint236_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8717 105.953H40.8101V107.462H52.8717V105.953Z",
    fill: "#98C6CF",
    stroke: "url(#paint237_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7847 107.478H39.8975V108.986H53.7847V107.478Z",
    fill: "#98C6CF",
    stroke: "url(#paint238_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1974 99.162L46.9196 98.6209C46.8829 98.585 46.8554 98.5804 46.8376 98.584C46.8172 98.5804 46.7861 98.585 46.7433 98.6209L46.4248 99.162C46.3942 99.2143 46.386 99.2799 46.4039 99.3394C46.4242 99.4097 46.4767 99.4615 46.541 99.4753L46.8126 99.5338V99.545L46.8376 99.5389L46.8661 99.545V99.5317L47.096 99.4748C47.152 99.4609 47.1974 99.4091 47.2157 99.3389C47.231 99.2799 47.2244 99.2143 47.1974 99.162Z",
    fill: "#98C6CF",
    stroke: "url(#paint239_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 100.031H46.5043C46.3876 100.031 46.2872 99.9466 46.2668 99.8307C46.2383 99.6702 46.3611 99.5225 46.5237 99.5225H47.096C47.2581 99.5225 47.3809 99.6702 47.3529 99.8307C47.332 99.9471 47.2316 100.031 47.1149 100.031Z",
    fill: "#98C6CF",
    stroke: "url(#paint240_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3496 100.31H47.2685C47.2685 100.31 47.1146 99.9859 46.7859 100.009C46.4582 100.032 46.3496 100.31 46.3496 100.31Z",
    fill: "#98C6CF",
    stroke: "url(#paint241_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3162 100.311C46.3162 100.311 45.8335 100.657 45.9258 100.773C46.0175 100.888 46.2703 100.865 46.2703 100.865L46.1556 101.351H47.5337L47.3268 100.842C47.3268 100.842 47.8782 100.842 47.6484 100.611C47.5215 100.483 47.2351 100.311 47.2351 100.311H46.3162Z",
    fill: "#98C6CF",
    stroke: "url(#paint242_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9381 108.551L39.5513 107.797C39.4998 107.747 39.4616 107.74 39.4371 107.746C39.4086 107.74 39.3653 107.747 39.3062 107.797L38.8623 108.551C38.8194 108.624 38.8087 108.715 38.8332 108.798C38.8617 108.896 38.9351 108.968 39.0243 108.988L39.403 109.069V109.085L39.4376 109.076L39.4774 109.085V109.067L39.798 108.987C39.8759 108.968 39.9396 108.895 39.9646 108.798C39.985 108.716 39.9758 108.625 39.9381 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint243_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8229 109.763H38.9718C38.8087 109.763 38.6695 109.646 38.641 109.484C38.6013 109.26 38.7725 109.055 38.9988 109.055H39.7964C40.0226 109.055 40.1939 109.26 40.1541 109.484C40.1251 109.646 39.986 109.763 39.8229 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint244_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7573 110.148H40.0375C40.0375 110.148 39.823 109.697 39.3653 109.729C38.9077 109.762 38.7573 110.148 38.7573 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint245_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6949 108.551L43.3081 107.797C43.2567 107.747 43.2184 107.74 43.194 107.746C43.1654 107.74 43.1221 107.747 43.063 107.797L42.6191 108.551C42.5763 108.624 42.5656 108.715 42.59 108.798C42.6186 108.896 42.692 108.968 42.7812 108.988L43.1598 109.069V109.085L43.1945 109.076L43.2342 109.085V109.067L43.5548 108.987C43.6328 108.968 43.6965 108.895 43.7214 108.798C43.7418 108.716 43.7321 108.625 43.6949 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint246_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5791 109.763H42.728C42.5649 109.763 42.4258 109.646 42.3972 109.484C42.358 109.26 42.5287 109.055 42.755 109.055H43.5526C43.7789 109.055 43.9496 109.26 43.9104 109.484C43.8818 109.646 43.7422 109.763 43.5791 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint247_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5137 110.148H43.7939C43.7939 110.148 43.5793 109.697 43.1217 109.729C42.6645 109.761 42.5137 110.148 42.5137 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint248_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4509 108.551L47.0641 107.797C47.0127 107.747 46.9749 107.74 46.95 107.746C46.9214 107.74 46.8781 107.747 46.819 107.797L46.3751 108.551C46.3323 108.624 46.3216 108.715 46.3455 108.798C46.3741 108.896 46.4475 108.968 46.5366 108.988L46.9153 109.069V109.085L46.95 109.076L46.9897 109.085V109.067L47.3103 108.987C47.3883 108.968 47.452 108.895 47.4769 108.798C47.4978 108.716 47.4887 108.625 47.4509 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint249_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3356 109.763H46.4845C46.3214 109.763 46.1822 109.646 46.1537 109.484C46.114 109.26 46.2852 109.055 46.5115 109.055H47.3091C47.5353 109.055 47.7061 109.26 47.6668 109.484C47.6378 109.646 47.4981 109.763 47.3356 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint250_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27 110.148H47.5502C47.5502 110.148 47.3357 109.697 46.878 109.729C46.4209 109.761 46.27 110.148 46.27 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint251_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4509 104.276L47.0641 103.522C47.0127 103.472 46.9749 103.465 46.95 103.47C46.9214 103.465 46.8781 103.472 46.819 103.522L46.3751 104.276C46.3323 104.349 46.3216 104.44 46.3455 104.523C46.3741 104.62 46.4475 104.693 46.5366 104.712L46.9153 104.794V104.81L46.95 104.801L46.9897 104.81V104.791L47.3103 104.712C47.3883 104.692 47.452 104.62 47.4769 104.523C47.4978 104.44 47.4887 104.349 47.4509 104.276Z",
    fill: "#98C6CF",
    stroke: "url(#paint252_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3356 105.488H46.4845C46.3214 105.488 46.1822 105.371 46.1537 105.209C46.114 104.985 46.2852 104.779 46.5115 104.779H47.3091C47.5353 104.779 47.7061 104.985 47.6668 105.209C47.6378 105.37 47.4981 105.488 47.3356 105.488Z",
    fill: "#98C6CF",
    stroke: "url(#paint253_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27 105.872H47.5502C47.5502 105.872 47.3357 105.421 46.878 105.454C46.4209 105.486 46.27 105.872 46.27 105.872Z",
    fill: "#98C6CF",
    stroke: "url(#paint254_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2072 108.551L50.8203 107.797C50.7689 107.747 50.7306 107.74 50.7062 107.746C50.6776 107.74 50.6343 107.747 50.5752 107.797L50.1313 108.551C50.0885 108.624 50.0778 108.715 50.1023 108.798C50.1308 108.896 50.2042 108.968 50.2934 108.988L50.672 109.069V109.085L50.7067 109.076L50.7464 109.085V109.067L51.067 108.987C51.145 108.968 51.2087 108.895 51.2337 108.798C51.254 108.716 51.2444 108.625 51.2072 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint255_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0914 109.763H50.2403C50.0772 109.763 49.9381 109.646 49.9096 109.484C49.8698 109.26 50.0411 109.055 50.2673 109.055H51.0649C51.2912 109.055 51.4624 109.26 51.4227 109.484C51.3941 109.646 51.2545 109.763 51.0914 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint256_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0259 110.148H51.3061C51.3061 110.148 51.0915 109.697 50.6339 109.729C50.1762 109.762 50.0259 110.148 50.0259 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint257_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9635 108.551L54.5767 107.797C54.5252 107.747 54.487 107.74 54.4625 107.746C54.434 107.74 54.3907 107.747 54.3315 107.797L53.8876 108.551C53.8448 108.624 53.8341 108.715 53.8586 108.798C53.8871 108.896 53.9605 108.968 54.0497 108.988L54.4284 109.069V109.085L54.463 109.076L54.5028 109.085V109.067L54.8234 108.987C54.9013 108.968 54.965 108.895 54.99 108.798C55.0104 108.716 55.0007 108.625 54.9635 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint258_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8481 109.763H53.997C53.834 109.763 53.6948 109.646 53.6663 109.484C53.627 109.26 53.7978 109.055 54.024 109.055H54.8216C55.0479 109.055 55.2192 109.26 55.1794 109.484C55.1504 109.646 55.0107 109.763 54.8481 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint259_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7827 110.148H55.0629C55.0629 110.148 54.8484 109.697 54.3907 109.729C53.9331 109.761 53.7827 110.148 53.7827 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint260_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7191 107.382L41.072 106.032L39.4248 107.382V117.695H42.7191V107.382Z",
    fill: "#98C6CF",
    stroke: "url(#paint261_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4804 107.377L51.635 106.026L49.7896 107.377V117.689H53.4804V107.377Z",
    fill: "#98C6CF",
    stroke: "url(#paint262_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1777 115.046H53.0567",
    stroke: "url(#paint263_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3638 116.352H53.0567",
    stroke: "url(#paint264_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6737 108.61L46.9624 106.032L43.5732 108.61V117.695H49.6737V108.61Z",
    fill: "#98C6CF",
    stroke: "url(#paint265_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3641 107.382L65.717 106.032L64.0703 107.382V117.695H67.3641V107.382Z",
    fill: "#98C6CF",
    stroke: "url(#paint266_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4603 108.61L60.3831 106.032L57.3599 108.61V117.695H63.4603V108.61Z",
    fill: "#98C6CF",
    stroke: "url(#paint267_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1249 110.942L72.6742 106.032L67.6084 110.942V117.695H77.1249V110.942Z",
    fill: "#98C6CF",
    stroke: "url(#paint268_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.454 110.942L34.9228 106.032L29.9375 110.942V117.695H39.454V110.942Z",
    fill: "#98C6CF",
    stroke: "url(#paint269_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8714 107.377L55.2243 106.026L53.5776 107.377V117.689H56.8714V107.377Z",
    fill: "#98C6CF",
    stroke: "url(#paint270_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9243 115.046H56.4939",
    stroke: "url(#paint271_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 116.352H56.4938",
    stroke: "url(#paint272_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0552 111.068H56.3241",
    stroke: "url(#paint273_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1653 117.369H39.303L37.3506 119.9H76.7586L77.1653 117.369Z",
    fill: "#98C6CF",
    stroke: "url(#paint274_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1656 117.369H52.7349L51.4756 119.9H76.9031L77.1656 117.369Z",
    fill: "#98C6CF",
    stroke: "url(#paint275_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1689 115.135H42.4248",
    stroke: "url(#paint276_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1689 116.607C30.4278 116.607 42.4248 116.607 42.4248 116.607",
    stroke: "url(#paint277_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7192 115.047H49.0705",
    stroke: "url(#paint278_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.064 116.346H49.0702",
    stroke: "url(#paint279_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4424 115.047H62.707",
    stroke: "url(#paint280_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1743 115.047H66.9361",
    stroke: "url(#paint281_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8423 115.047H76.495",
    stroke: "url(#paint282_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4424 116.346H63.1692",
    stroke: "url(#paint283_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5195 116.346H66.8501",
    stroke: "url(#paint284_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0347 116.346H76.6476",
    stroke: "url(#paint285_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5825 111.147H38.7979",
    stroke: "url(#paint286_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.04 111.069H49.2037",
    stroke: "url(#paint287_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0498 111.069H42.3187",
    stroke: "url(#paint288_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4561 111.069H52.725",
    stroke: "url(#paint289_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5396 111.069H66.8085",
    stroke: "url(#paint290_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0459 111.069H63.2096",
    stroke: "url(#paint291_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4517 111.069H76.2762",
    stroke: "url(#paint292_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.067 144.747H155.727V118.96H116.067V144.747Z",
    fill: "#98C6CF",
    stroke: "url(#paint293_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.122 121.864H156.322V119.655H144.122V121.864Z",
    fill: "#98C6CF",
    stroke: "url(#paint294_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.591 121.849V140.405L157.664 143.228V144.702H142.78V143.106L144.732 139.913V121.797L155.591 121.849Z",
    fill: "#98C6CF",
    stroke: "url(#paint295_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.686 120.518V140.406",
    stroke: "url(#paint296_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.172 136.844L148.026 136.292L148.88 136.844V139.3H147.172V136.844Z",
    fill: "#98C6CF",
    stroke: "url(#paint297_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.336 121.864H142.536V119.655H130.336V121.864Z",
    fill: "#98C6CF",
    stroke: "url(#paint298_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.804 121.849V140.405L143.878 143.228V144.702H128.994V143.106L130.946 139.913V121.797L141.804 121.849Z",
    fill: "#98C6CF",
    stroke: "url(#paint299_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9 120.518V140.406",
    stroke: "url(#paint300_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.386 136.844L134.24 136.292L135.094 136.844V139.3H133.386V136.844Z",
    fill: "#98C6CF",
    stroke: "url(#paint301_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.932 140.227H132.229",
    stroke: "url(#paint302_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.602 141.35H146.029",
    stroke: "url(#paint303_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.602 135.456H118.196",
    stroke: "url(#paint304_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.602 134.167H118.196",
    stroke: "url(#paint305_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.602 132.883H118.196",
    stroke: "url(#paint306_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38 120.084V140.351",
    stroke: "url(#paint307_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.796 129.965H124.023V124.961H119.796V129.965Z",
    stroke: "url(#paint308_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.769 126.964H125.64V124.837H124.769V126.964Z",
    stroke: "url(#paint309_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.18 126.964H119.051V124.837H118.18V126.964Z",
    stroke: "url(#paint310_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.18 130.592H119.051V128.465H118.18V130.592Z",
    stroke: "url(#paint311_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.769 130.967H125.64V128.84H124.769V130.967Z",
    stroke: "url(#paint312_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.977 129.965H135.92V124.961H132.977V129.965Z",
    stroke: "url(#paint313_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44 126.964H137.046V124.837H136.44V126.964Z",
    stroke: "url(#paint314_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.852 126.964H132.458V124.837H131.852V126.964Z",
    stroke: "url(#paint315_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.852 130.592H132.458V128.465H131.852V130.592Z",
    stroke: "url(#paint316_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44 130.967H137.046V128.84H136.44V130.967Z",
    stroke: "url(#paint317_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.506 129.965H149.724V124.961H146.506V129.965Z",
    stroke: "url(#paint318_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.292 126.964H150.954V124.837H150.292V126.964Z",
    stroke: "url(#paint319_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.276 126.964H145.938V124.837H145.276V126.964Z",
    stroke: "url(#paint320_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.276 130.592H145.938V128.465H145.276V130.592Z",
    stroke: "url(#paint321_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.292 130.967H150.954V128.84H150.292V130.967Z",
    stroke: "url(#paint322_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5 129.902H143.869V125.264H142.5V129.902Z",
    stroke: "url(#paint323_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.206 129.902H140.575V125.264H139.206V129.902Z",
    stroke: "url(#paint324_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.932 129.902H154.3V125.264H152.932V129.902Z",
    stroke: "url(#paint325_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.529 129.902H129.897V125.264H128.529V129.902Z",
    stroke: "url(#paint326_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.591 102.968H136.714V101.459H132.591V102.968Z",
    fill: "#98C6CF",
    stroke: "url(#paint327_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.805 104.351H138.501V102.842H130.805V104.351Z",
    fill: "#98C6CF",
    stroke: "url(#paint328_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.614 106.063H139.692V104.555H129.614V106.063Z",
    fill: "#98C6CF",
    stroke: "url(#paint329_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.622 107.467H140.684V105.958H128.622V107.467Z",
    fill: "#98C6CF",
    stroke: "url(#paint330_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.709 108.986H141.596V107.478H127.709V108.986Z",
    fill: "#98C6CF",
    stroke: "url(#paint331_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.296 99.162L134.574 98.6209C134.61 98.585 134.638 98.5804 134.656 98.584C134.676 98.5804 134.707 98.585 134.75 98.6209L135.069 99.162C135.099 99.2143 135.107 99.2799 135.089 99.3394C135.069 99.4097 135.017 99.4615 134.952 99.4753L134.681 99.5338V99.545L134.656 99.5389L134.627 99.545V99.5317L134.397 99.4748C134.341 99.4609 134.296 99.4091 134.278 99.3389C134.262 99.2799 134.269 99.2143 134.296 99.162Z",
    fill: "#98C6CF",
    stroke: "url(#paint332_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.379 100.031H134.989C135.106 100.031 135.206 99.9466 135.227 99.8307C135.255 99.6702 135.132 99.5225 134.97 99.5225H134.398C134.236 99.5225 134.113 99.6702 134.141 99.8307C134.162 99.9471 134.262 100.031 134.379 100.031Z",
    fill: "#98C6CF",
    stroke: "url(#paint333_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.143 100.31H134.225C134.225 100.31 134.379 99.9859 134.707 100.009C135.035 100.032 135.143 100.31 135.143 100.31Z",
    fill: "#98C6CF",
    stroke: "url(#paint334_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.177 100.311C135.177 100.311 135.66 100.657 135.568 100.773C135.476 100.888 135.223 100.865 135.223 100.865L135.338 101.351H133.96L134.167 100.842C134.167 100.842 133.615 100.842 133.845 100.611C133.972 100.483 134.258 100.311 134.258 100.311H135.177Z",
    fill: "#98C6CF",
    stroke: "url(#paint335_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.556 108.551L141.943 107.797C141.994 107.747 142.033 107.74 142.057 107.746C142.086 107.74 142.129 107.747 142.188 107.797L142.632 108.551C142.675 108.624 142.685 108.715 142.661 108.798C142.632 108.896 142.559 108.968 142.47 108.988L142.091 109.069V109.085L142.056 109.076L142.017 109.085V109.067L141.696 108.987C141.618 108.968 141.554 108.895 141.53 108.798C141.509 108.716 141.519 108.625 141.556 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint336_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.671 109.763H142.523C142.686 109.763 142.825 109.646 142.853 109.484C142.893 109.26 142.722 109.055 142.496 109.055H141.698C141.472 109.055 141.3 109.26 141.34 109.484C141.369 109.646 141.508 109.763 141.671 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint337_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.737 110.148H141.457C141.457 110.148 141.671 109.697 142.129 109.729C142.586 109.761 142.737 110.148 142.737 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint338_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8 108.551L138.187 107.797C138.238 107.747 138.276 107.74 138.301 107.746C138.329 107.74 138.373 107.747 138.432 107.797L138.876 108.551C138.918 108.624 138.929 108.715 138.905 108.798C138.876 108.896 138.803 108.968 138.714 108.988L138.335 109.069V109.085L138.3 109.076L138.26 109.085V109.067L137.94 108.987C137.862 108.968 137.798 108.895 137.773 108.798C137.753 108.716 137.762 108.625 137.8 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint339_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.915 109.763H138.766C138.929 109.763 139.068 109.646 139.097 109.484C139.136 109.26 138.965 109.055 138.739 109.055H137.941C137.715 109.055 137.544 109.26 137.583 109.484C137.612 109.646 137.752 109.763 137.915 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint340_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.98 110.148H137.7C137.7 110.148 137.915 109.697 138.372 109.729C138.83 109.761 138.98 110.148 138.98 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint341_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.043 108.551L134.43 107.797C134.481 107.747 134.519 107.74 134.544 107.746C134.572 107.74 134.616 107.747 134.675 107.797L135.119 108.551C135.161 108.624 135.172 108.715 135.148 108.798C135.119 108.896 135.046 108.968 134.957 108.988L134.578 109.069V109.085L134.543 109.076L134.504 109.085V109.067L134.183 108.987C134.105 108.968 134.041 108.895 134.016 108.798C133.996 108.716 134.006 108.625 134.043 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint342_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.159 109.763H135.01C135.173 109.763 135.312 109.646 135.341 109.484C135.38 109.26 135.209 109.055 134.983 109.055H134.185C133.959 109.055 133.788 109.26 133.827 109.484C133.856 109.646 133.996 109.763 134.159 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint343_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.225 110.148H133.944C133.944 110.148 134.159 109.697 134.617 109.729C135.074 109.761 135.225 110.148 135.225 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint344_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.043 104.276L134.43 103.522C134.481 103.472 134.519 103.465 134.544 103.47C134.572 103.465 134.616 103.472 134.675 103.522L135.119 104.276C135.161 104.349 135.172 104.44 135.148 104.523C135.119 104.62 135.046 104.693 134.957 104.712L134.578 104.794V104.81L134.543 104.801L134.504 104.81V104.791L134.183 104.712C134.105 104.692 134.041 104.62 134.016 104.523C133.996 104.44 134.006 104.349 134.043 104.276Z",
    fill: "#98C6CF",
    stroke: "url(#paint345_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.159 105.488H135.01C135.173 105.488 135.312 105.371 135.341 105.209C135.38 104.985 135.209 104.779 134.983 104.779H134.185C133.959 104.779 133.788 104.985 133.827 105.209C133.856 105.37 133.996 105.488 134.159 105.488Z",
    fill: "#98C6CF",
    stroke: "url(#paint346_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.225 105.872H133.944C133.944 105.872 134.159 105.421 134.617 105.454C135.074 105.486 135.225 105.872 135.225 105.872Z",
    fill: "#98C6CF",
    stroke: "url(#paint347_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.288 108.551L130.674 107.797C130.726 107.747 130.764 107.74 130.789 107.746C130.817 107.74 130.86 107.747 130.92 107.797L131.363 108.551C131.406 108.624 131.417 108.715 131.392 108.798C131.364 108.896 131.291 108.968 131.201 108.988L130.823 109.069V109.085L130.788 109.076L130.748 109.085V109.067L130.428 108.987C130.35 108.968 130.286 108.895 130.261 108.798C130.241 108.716 130.25 108.625 130.288 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint348_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.402 109.763H131.254C131.417 109.763 131.556 109.646 131.584 109.484C131.624 109.26 131.453 109.055 131.227 109.055H130.429C130.203 109.055 130.031 109.26 130.071 109.484C130.1 109.646 130.239 109.763 130.402 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint349_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.468 110.148H130.188C130.188 110.148 130.403 109.697 130.86 109.729C131.317 109.761 131.468 110.148 131.468 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint350_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.531 108.551L126.917 107.797C126.969 107.747 127.007 107.74 127.032 107.746C127.06 107.74 127.103 107.747 127.163 107.797L127.606 108.551C127.649 108.624 127.66 108.715 127.636 108.798C127.607 108.896 127.534 108.968 127.444 108.988L127.066 109.069V109.085L127.031 109.076L126.991 109.085V109.067L126.671 108.987C126.593 108.968 126.529 108.895 126.504 108.798C126.484 108.716 126.493 108.625 126.531 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint351_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.646 109.763H127.497C127.66 109.763 127.799 109.646 127.828 109.484C127.868 109.26 127.696 109.055 127.47 109.055H126.673C126.446 109.055 126.275 109.26 126.315 109.484C126.343 109.646 126.483 109.763 126.646 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint352_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.712 110.148H126.432C126.432 110.148 126.646 109.697 127.104 109.729C127.561 109.761 127.712 110.148 127.712 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint353_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.991 102.968H150.113V101.459H145.991V102.968Z",
    fill: "#98C6CF",
    stroke: "url(#paint354_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.204 104.351H151.9V102.842H144.204V104.351Z",
    fill: "#98C6CF",
    stroke: "url(#paint355_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.013 106.063H153.091V104.555H143.013V106.063Z",
    fill: "#98C6CF",
    stroke: "url(#paint356_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.021 107.467H154.083V105.958H142.021V107.467Z",
    fill: "#98C6CF",
    stroke: "url(#paint357_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.108 108.986H154.996V107.478H141.108V108.986Z",
    fill: "#98C6CF",
    stroke: "url(#paint358_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.696 99.162L147.974 98.6209C148.011 98.585 148.038 98.5804 148.056 98.584C148.076 98.5804 148.107 98.585 148.15 98.6209L148.469 99.162C148.5 99.2143 148.508 99.2799 148.49 99.3394C148.469 99.4097 148.417 99.4615 148.353 99.4753L148.081 99.5338V99.545L148.056 99.5389L148.027 99.545V99.5317L147.798 99.4748C147.742 99.4609 147.696 99.4091 147.678 99.3389C147.663 99.2799 147.669 99.2143 147.696 99.162Z",
    fill: "#98C6CF",
    stroke: "url(#paint359_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.779 100.031H148.389C148.506 100.031 148.606 99.9466 148.627 99.8307C148.655 99.6702 148.532 99.5225 148.37 99.5225H147.797C147.635 99.5225 147.513 99.6702 147.541 99.8307C147.562 99.9471 147.662 100.031 147.779 100.031Z",
    fill: "#98C6CF",
    stroke: "url(#paint360_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.543 100.31H147.625C147.625 100.31 147.778 99.9859 148.107 100.009C148.435 100.032 148.543 100.31 148.543 100.31Z",
    fill: "#98C6CF",
    stroke: "url(#paint361_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.577 100.311C148.577 100.311 149.059 100.657 148.968 100.773C148.876 100.888 148.623 100.865 148.623 100.865L148.738 101.351H147.36L147.567 100.842C147.567 100.842 147.015 100.842 147.245 100.611C147.372 100.483 147.658 100.311 147.658 100.311H148.577Z",
    fill: "#98C6CF",
    stroke: "url(#paint362_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.955 108.551L155.342 107.797C155.393 107.747 155.432 107.74 155.456 107.746C155.485 107.74 155.528 107.747 155.587 107.797L156.031 108.551C156.074 108.624 156.085 108.715 156.06 108.798C156.032 108.896 155.958 108.968 155.869 108.988L155.49 109.069V109.085L155.456 109.076L155.417 109.086V109.067L155.096 108.988C155.018 108.968 154.955 108.896 154.93 108.798C154.908 108.716 154.918 108.625 154.955 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint363_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.07 109.763H155.921C156.084 109.763 156.224 109.646 156.252 109.484C156.292 109.26 156.121 109.055 155.894 109.055H155.097C154.871 109.055 154.7 109.26 154.739 109.484C154.768 109.646 154.908 109.763 155.07 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint364_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.136 110.148H154.856C154.856 110.148 155.071 109.697 155.528 109.729C155.986 109.761 156.136 110.148 156.136 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint365_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.199 108.551L151.586 107.797C151.637 107.747 151.675 107.74 151.7 107.746C151.729 107.74 151.772 107.747 151.831 107.797L152.275 108.551C152.318 108.624 152.328 108.715 152.304 108.798C152.275 108.896 152.202 108.968 152.113 108.988L151.734 109.069V109.085L151.7 109.076L151.66 109.085V109.067L151.34 108.988C151.262 108.969 151.198 108.896 151.173 108.799C151.152 108.716 151.161 108.625 151.199 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint366_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.314 109.763H152.165C152.328 109.763 152.467 109.646 152.496 109.484C152.536 109.26 152.364 109.055 152.138 109.055H151.34C151.114 109.055 150.943 109.26 150.983 109.484C151.012 109.646 151.151 109.763 151.314 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint367_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.38 110.148H151.1C151.1 110.148 151.314 109.697 151.772 109.729C152.229 109.761 152.38 110.148 152.38 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint368_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.442 108.551L147.829 107.797C147.881 107.747 147.919 107.74 147.943 107.746C147.972 107.74 148.015 107.747 148.074 107.797L148.518 108.551C148.561 108.624 148.572 108.715 148.547 108.798C148.519 108.896 148.445 108.968 148.356 108.988L147.977 109.069V109.085L147.943 109.076L147.903 109.085V109.067L147.582 108.987C147.504 108.968 147.441 108.895 147.416 108.798C147.395 108.716 147.405 108.625 147.442 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint369_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.558 109.763H148.409C148.572 109.763 148.711 109.646 148.74 109.484C148.78 109.26 148.608 109.055 148.382 109.055H147.585C147.358 109.055 147.188 109.26 147.227 109.484C147.255 109.646 147.395 109.763 147.558 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint370_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.624 110.148H147.344C147.344 110.148 147.558 109.697 148.016 109.729C148.473 109.761 148.624 110.148 148.624 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint371_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.442 104.276L147.829 103.522C147.881 103.472 147.919 103.465 147.943 103.47C147.972 103.465 148.015 103.472 148.074 103.522L148.518 104.276C148.561 104.349 148.572 104.44 148.547 104.523C148.519 104.62 148.445 104.693 148.356 104.712L147.977 104.794V104.81L147.943 104.801L147.903 104.81V104.791L147.582 104.712C147.504 104.692 147.441 104.62 147.416 104.523C147.395 104.44 147.405 104.349 147.442 104.276Z",
    fill: "#98C6CF",
    stroke: "url(#paint372_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.558 105.488H148.409C148.572 105.488 148.711 105.371 148.74 105.209C148.78 104.985 148.608 104.779 148.382 104.779H147.585C147.358 104.779 147.188 104.985 147.227 105.209C147.255 105.37 147.395 105.488 147.558 105.488Z",
    fill: "#98C6CF",
    stroke: "url(#paint373_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.624 105.872H147.344C147.344 105.872 147.558 105.421 148.016 105.454C148.473 105.486 148.624 105.872 148.624 105.872Z",
    fill: "#98C6CF",
    stroke: "url(#paint374_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.687 108.551L144.073 107.797C144.125 107.747 144.163 107.74 144.187 107.746C144.216 107.74 144.259 107.747 144.318 107.797L144.762 108.551C144.805 108.624 144.816 108.715 144.791 108.798C144.763 108.896 144.689 108.968 144.6 108.988L144.222 109.069V109.085L144.187 109.076L144.147 109.085V109.067L143.827 108.987C143.749 108.968 143.685 108.895 143.66 108.798C143.64 108.716 143.649 108.625 143.687 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint375_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.801 109.763H144.652C144.816 109.763 144.955 109.646 144.983 109.484C145.022 109.26 144.852 109.055 144.625 109.055H143.828C143.602 109.055 143.43 109.26 143.47 109.484C143.499 109.646 143.638 109.763 143.801 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint376_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.867 110.148H143.587C143.587 110.148 143.801 109.697 144.259 109.729C144.716 109.761 144.867 110.148 144.867 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint377_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93 108.551L140.316 107.797C140.368 107.747 140.406 107.74 140.431 107.746C140.459 107.74 140.502 107.747 140.561 107.797L141.005 108.551C141.048 108.624 141.059 108.715 141.034 108.798C141.006 108.896 140.933 108.968 140.843 108.988L140.465 109.069V109.085L140.43 109.076L140.39 109.085V109.067L140.07 108.987C139.992 108.968 139.928 108.895 139.903 108.798C139.883 108.716 139.892 108.625 139.93 108.551Z",
    fill: "#98C6CF",
    stroke: "url(#paint378_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.045 109.763H140.897C141.06 109.763 141.199 109.646 141.227 109.484C141.267 109.26 141.096 109.055 140.869 109.055H140.072C139.846 109.055 139.675 109.26 139.714 109.484C139.743 109.646 139.882 109.763 140.045 109.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint379_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.111 110.148H139.831C139.831 110.148 140.046 109.697 140.503 109.729C140.96 109.761 141.111 110.148 141.111 110.148Z",
    fill: "#98C6CF",
    stroke: "url(#paint380_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.175 107.382L153.822 106.032L155.469 107.382V117.695H152.175V107.382Z",
    fill: "#98C6CF",
    stroke: "url(#paint381_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.414 107.377L143.258 106.026L145.104 107.377V117.689H141.414V107.377Z",
    fill: "#98C6CF",
    stroke: "url(#paint382_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.715 115.046H141.836",
    stroke: "url(#paint383_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.529 116.352H141.836",
    stroke: "url(#paint384_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.22 108.61L147.932 106.032L151.321 108.61V117.695H145.22V108.61Z",
    fill: "#98C6CF",
    stroke: "url(#paint385_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.529 107.382L129.176 106.032L130.824 107.382V117.695H127.529V107.382Z",
    fill: "#98C6CF",
    stroke: "url(#paint386_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.434 108.61L134.511 106.032L137.533 108.61V117.695H131.434V108.61Z",
    fill: "#98C6CF",
    stroke: "url(#paint387_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.769 110.942L122.22 106.032L127.285 110.942V117.695H117.769V110.942Z",
    fill: "#98C6CF",
    stroke: "url(#paint388_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.44 110.942L159.971 106.032L164.956 110.942V117.695H155.44V110.942Z",
    fill: "#98C6CF",
    stroke: "url(#paint389_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.022 107.377L139.669 106.026L141.316 107.377V117.689H138.022V107.377Z",
    fill: "#98C6CF",
    stroke: "url(#paint390_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.969 115.046H138.399",
    stroke: "url(#paint391_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.803 116.352H138.399",
    stroke: "url(#paint392_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.839 111.068H138.569",
    stroke: "url(#paint393_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.728 117.369H155.591L157.543 119.9H118.135L117.728 117.369Z",
    fill: "#98C6CF",
    stroke: "url(#paint394_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.728 117.369H142.159L143.419 119.9H117.991L117.728 117.369Z",
    fill: "#98C6CF",
    stroke: "url(#paint395_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.725 115.135H152.469",
    stroke: "url(#paint396_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.725 116.607C164.466 116.607 152.469 116.607 152.469 116.607",
    stroke: "url(#paint397_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.174 115.047H145.824",
    stroke: "url(#paint398_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.829 116.346H145.824",
    stroke: "url(#paint399_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.452 115.047H132.187",
    stroke: "url(#paint400_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.719 115.047H127.958",
    stroke: "url(#paint401_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.051 115.047H118.399",
    stroke: "url(#paint402_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.452 116.346H131.725",
    stroke: "url(#paint403_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.374 116.346H128.043",
    stroke: "url(#paint404_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.859 116.346H118.246",
    stroke: "url(#paint405_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.311 111.147H156.095",
    stroke: "url(#paint406_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.854 111.069H145.689",
    stroke: "url(#paint407_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.844 111.069H152.575",
    stroke: "url(#paint408_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.437 111.069H142.168",
    stroke: "url(#paint409_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.354 111.069H128.085",
    stroke: "url(#paint410_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.848 111.069H131.684",
    stroke: "url(#paint411_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.442 111.069H118.618",
    stroke: "url(#paint412_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4692 100.859H164.445L165.639 99.0947H29.0244L30.4692 100.859Z",
    fill: "url(#paint413_linear_2761_32788)",
    stroke: "url(#paint414_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0244 99.0902H165.639L162.62 96.7881H32.1353L29.0244 99.0902Z",
    fill: "#98C6CF",
    stroke: "url(#paint415_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.912 74.4414C114.026 65.5542 106.571 58.6152 97.5054 58.6152C88.4399 58.6152 80.9849 65.5537 80.0986 74.4414H114.912Z",
    fill: "#98C6CF",
    stroke: "url(#paint416_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.548 74.4414C108.934 65.5542 103.777 58.6152 97.5047 58.6152C91.2326 58.6152 86.075 65.5537 85.4619 74.4414H109.548Z",
    fill: "#98C6CF",
    stroke: "url(#paint417_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.554 74.4414C103.246 65.5542 100.656 58.6152 97.5055 58.6152C94.3554 58.6152 91.7649 65.5537 91.457 74.4414H103.554Z",
    fill: "#98C6CF",
    stroke: "url(#paint418_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.824 74.4365H80.0986V79.0596H114.824V74.4365Z",
    fill: "#98C6CF",
    stroke: "url(#paint419_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.721 71.2422C80.4519 72.1612 80.2598 73.1125 80.1426 74.0873H114.823V73.7278C114.703 72.8786 114.525 72.0483 114.289 71.2422H80.721Z",
    fill: "#98C6CF",
    stroke: "url(#paint420_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.824 78.7061H80.0986V81.5512H114.824V78.7061Z",
    fill: "#98C6CF",
    stroke: "url(#paint421_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.824 95.0665H80.0987V85.3598L78.2686 83.9941H116.654L114.824 85.2029V95.0665Z",
    fill: "#98C6CF",
    stroke: "url(#paint422_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9784 85.27H114.824V85.2029L116.654 83.9941H78.2686L79.9784 85.27Z",
    fill: "url(#paint423_linear_2761_32788)",
    stroke: "url(#paint424_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.654 83.9677H78.2686L80.0987 81.123H114.824L116.654 83.9677Z",
    fill: "#98C6CF",
    stroke: "url(#paint425_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8689 69.3418C84.1707 69.3418 83.6045 69.9115 83.6045 70.6141V73.771H86.1333V70.6141C86.1333 69.9115 85.5671 69.3418 84.8689 69.3418Z",
    fill: "#98C6CF",
    stroke: "url(#paint426_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22 69.3418C108.522 69.3418 107.956 69.9115 107.956 70.6141V73.771H110.484V70.6141C110.484 69.9115 109.918 69.3418 109.22 69.3418Z",
    fill: "#98C6CF",
    stroke: "url(#paint427_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7071 50.0618L97.5747 47.8556C97.4238 47.709 97.3127 47.6895 97.2403 47.7043C97.1573 47.6895 97.0299 47.709 96.8571 47.8556L95.558 50.0618C95.4321 50.2751 95.4005 50.5423 95.4724 50.7859C95.5565 51.0715 95.7705 51.2833 96.0315 51.3397L97.1394 51.5787V51.6254L97.2403 51.6003L97.3565 51.6254V51.5715L98.2943 51.3397C98.5221 51.2833 98.7086 51.0715 98.7815 50.7859C98.8442 50.5423 98.8167 50.2756 98.7071 50.0618Z",
    fill: "#98C6CF",
    stroke: "url(#paint428_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3696 53.6104H95.88C95.403 53.6104 94.9953 53.2663 94.9117 52.794C94.796 52.1387 95.297 51.5371 95.9585 51.5371H98.2916C98.9531 51.5371 99.4541 52.1387 99.3384 52.794C99.2543 53.2663 98.8461 53.6104 98.3696 53.6104Z",
    fill: "#98C6CF",
    stroke: "url(#paint429_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2515 54.7348H98.9978C98.9978 54.7348 98.3694 53.4154 97.0311 53.5097C95.6928 53.6036 95.2515 54.7348 95.2515 54.7348Z",
    fill: "#98C6CF",
    stroke: "url(#paint430_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1142 54.7368C95.1142 54.7368 93.1475 56.1507 93.522 56.6215C93.8966 57.0927 94.9271 56.9984 94.9271 56.9984L94.4588 58.9774H100.078L99.2351 56.904C99.2351 56.904 101.483 56.904 100.546 55.9615C100.029 55.4409 98.8605 54.7363 98.8605 54.7363H95.1142V54.7368Z",
    fill: "#98C6CF",
    stroke: "url(#paint431_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0918 58.9746V74.2418",
    stroke: "url(#paint432_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.911 94.4854C114.025 85.5982 106.57 78.6592 97.5049 78.6592C88.4394 78.6592 80.9844 85.5977 80.0981 94.4854H114.911Z",
    fill: "#98C6CF",
    stroke: "url(#paint433_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.547 94.4854C108.934 85.5982 103.776 78.6592 97.5043 78.6592C91.2321 78.6592 86.0745 85.5977 85.4614 94.4854H109.547Z",
    fill: "#98C6CF",
    stroke: "url(#paint434_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.553 94.4854C103.246 85.5982 100.655 78.6592 97.505 78.6592C94.3549 78.6592 91.7644 85.5977 91.4565 94.4854H103.553Z",
    fill: "#98C6CF",
    stroke: "url(#paint435_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7205 91.2861C80.4514 92.2051 80.2593 93.1564 80.1421 94.1313H114.823V93.7718C114.703 92.9225 114.525 92.0923 114.289 91.2861H80.7205Z",
    fill: "#98C6CF",
    stroke: "url(#paint436_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8684 89.3916C84.1702 89.3916 83.604 89.9613 83.604 90.6639V93.8209H86.1328V90.6639C86.1328 89.9613 85.5666 89.3916 84.8684 89.3916Z",
    fill: "#98C6CF",
    stroke: "url(#paint437_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.219 89.3916C108.521 89.3916 107.955 89.9613 107.955 90.6639V93.8209H110.484V90.6639C110.484 89.9613 109.918 89.3916 109.219 89.3916Z",
    fill: "#98C6CF",
    stroke: "url(#paint438_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7066 70.1116L97.5742 67.9054C97.4233 67.7588 97.3122 67.7393 97.2399 67.7542C97.1568 67.7393 97.0294 67.7588 96.8566 67.9054L95.5575 70.1116C95.4316 70.3249 95.4001 70.5921 95.4719 70.8357C95.556 71.1213 95.77 71.3331 96.031 71.3895L97.1389 71.6285V71.6752L97.2399 71.6501L97.3561 71.6752V71.6213L98.2938 71.389C98.5216 71.3326 98.7081 71.1208 98.781 70.8352C98.8437 70.5921 98.8162 70.3249 98.7066 70.1116Z",
    fill: "#98C6CF",
    stroke: "url(#paint439_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3691 73.6603H95.8795C95.4025 73.6603 94.9948 73.3162 94.9112 72.8438C94.7955 72.1885 95.2965 71.5869 95.958 71.5869H98.2911C98.9527 71.5869 99.4536 72.1885 99.3379 72.8438C99.2539 73.3162 98.8456 73.6603 98.3691 73.6603Z",
    fill: "#98C6CF",
    stroke: "url(#paint440_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.251 74.7846H98.9973C98.9973 74.7846 98.369 73.4652 97.0306 73.5595C95.6923 73.6539 95.251 74.7846 95.251 74.7846Z",
    fill: "#98C6CF",
    stroke: "url(#paint441_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1137 74.7866C95.1137 74.7866 93.147 76.2005 93.5216 76.6713C93.8961 77.1425 94.9266 77.0482 94.9266 77.0482L94.4583 79.0272H100.078L99.2346 76.9538C99.2346 76.9538 101.482 76.9538 100.546 76.0113C100.029 75.4907 98.8601 74.7861 98.8601 74.7861L95.1137 74.7866Z",
    fill: "#98C6CF",
    stroke: "url(#paint442_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0913 79.0303V94.2975",
    stroke: "url(#paint443_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0983 95.0654L75.2944 98.4188H119.338L114.823 95.0654H80.0983Z",
    fill: "#98C6CF",
    stroke: "url(#paint444_linear_2761_32788)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2944 98.416L79.0765 101.731V139.753H115.556V102.345L119.338 98.416H75.2944Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.2944 98.416L79.0765 101.731V139.753H115.556V102.345L119.338 98.416H75.2944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2944 98.416L79.0765 101.731V139.753H115.556V102.345L119.338 98.416H75.2944Z",
    stroke: "url(#paint445_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.812 98.416L86.9596 101.731V109.465H107.673V102.345L109.821 98.416H84.812Z",
    fill: "#98C6CF",
    stroke: "url(#paint446_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8351 99.7668H118.038L119.338 98.416H75.2944L76.8351 99.7668Z",
    fill: "url(#paint447_linear_2761_32788)",
    stroke: "url(#paint448_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.62 101.866H105.81V103.26H109.62V101.866Z",
    fill: "#98C6CF",
    stroke: "url(#paint449_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.271 103.146H104.159V104.539H111.271V103.146Z",
    fill: "#98C6CF",
    stroke: "url(#paint450_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.371 104.731H103.059V106.125H112.371V104.731Z",
    fill: "#98C6CF",
    stroke: "url(#paint451_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.287 106.026H102.142V107.42H113.287V106.026Z",
    fill: "#98C6CF",
    stroke: "url(#paint452_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.131 107.426H101.299V108.82H114.131V107.426Z",
    fill: "#98C6CF",
    stroke: "url(#paint453_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.404 109.994H77.2368V111.903H116.404V109.994Z",
    fill: "#98C6CF",
    stroke: "url(#paint454_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.404 111.873H77.2368V113.782H116.404V111.873Z",
    fill: "#98C6CF",
    stroke: "url(#paint455_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.404 113.763H77.2368V115.671H116.404V113.763Z",
    fill: "#98C6CF",
    stroke: "url(#paint456_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.404 115.646H77.2368V117.555H116.404V115.646Z",
    fill: "#98C6CF",
    stroke: "url(#paint457_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.044 99.7395L107.787 99.2395C107.753 99.2061 107.728 99.2015 107.711 99.2051C107.693 99.2015 107.664 99.2061 107.624 99.2395L107.33 99.7395C107.301 99.7877 107.294 99.8482 107.31 99.9036C107.329 99.9682 107.378 100.016 107.437 100.029L107.689 100.084V100.094L107.711 100.089L107.738 100.094V100.082L107.95 100.03C108.002 100.017 108.044 99.9692 108.061 99.9041C108.075 99.8482 108.069 99.7877 108.044 99.7395Z",
    fill: "#98C6CF",
    stroke: "url(#paint458_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.967 100.54H107.403C107.295 100.54 107.203 100.462 107.183 100.355C107.157 100.206 107.271 100.07 107.42 100.07H107.949C108.099 100.07 108.212 100.207 108.186 100.355C108.168 100.462 108.075 100.54 107.967 100.54Z",
    fill: "#98C6CF",
    stroke: "url(#paint459_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.261 100.793H108.11C108.11 100.793 107.968 100.494 107.664 100.516C107.361 100.537 107.261 100.793 107.261 100.793Z",
    fill: "#98C6CF",
    stroke: "url(#paint460_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.23 100.796C107.23 100.796 106.784 101.116 106.869 101.223C106.954 101.33 107.188 101.309 107.188 101.309L107.082 101.757H108.355L108.164 101.288C108.164 101.288 108.674 101.288 108.461 101.074C108.344 100.956 108.079 100.796 108.079 100.796L107.23 100.796Z",
    fill: "#98C6CF",
    stroke: "url(#paint461_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.337 108.412L100.979 107.715C100.932 107.669 100.897 107.663 100.874 107.667C100.847 107.663 100.807 107.669 100.752 107.715L100.342 108.412C100.302 108.479 100.293 108.564 100.315 108.641C100.342 108.731 100.409 108.798 100.491 108.816L100.842 108.891V108.906L100.874 108.898L100.91 108.906V108.889L101.206 108.816C101.278 108.798 101.337 108.731 101.36 108.641C101.38 108.564 101.372 108.48 101.337 108.412Z",
    fill: "#98C6CF",
    stroke: "url(#paint462_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23 109.527H100.444C100.294 109.527 100.165 109.418 100.138 109.269C100.101 109.062 100.26 108.872 100.468 108.872H101.205C101.414 108.872 101.572 109.062 101.536 109.269C101.51 109.418 101.381 109.527 101.23 109.527Z",
    fill: "#98C6CF",
    stroke: "url(#paint463_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.245 109.886H101.428C101.428 109.886 101.23 109.47 100.807 109.5C100.385 109.529 100.245 109.886 100.245 109.886Z",
    fill: "#98C6CF",
    stroke: "url(#paint464_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.807 108.412L104.45 107.715C104.402 107.669 104.367 107.663 104.344 107.667C104.318 107.663 104.278 107.669 104.223 107.715L103.813 108.412C103.773 108.479 103.763 108.564 103.785 108.641C103.812 108.731 103.88 108.798 103.962 108.816L104.312 108.891V108.906L104.344 108.898L104.381 108.906V108.889L104.677 108.816C104.749 108.798 104.808 108.731 104.831 108.641C104.851 108.564 104.842 108.48 104.807 108.412Z",
    fill: "#98C6CF",
    stroke: "url(#paint465_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.701 109.527H103.915C103.764 109.527 103.635 109.418 103.609 109.269C103.572 109.062 103.731 108.872 103.94 108.872H104.677C104.885 108.872 105.043 109.062 105.007 109.269C104.98 109.418 104.851 109.527 104.701 109.527Z",
    fill: "#98C6CF",
    stroke: "url(#paint466_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.716 109.886H104.899C104.899 109.886 104.701 109.47 104.278 109.5C103.855 109.529 103.716 109.886 103.716 109.886Z",
    fill: "#98C6CF",
    stroke: "url(#paint467_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.278 108.412L107.92 107.715C107.873 107.669 107.837 107.663 107.815 107.667C107.789 107.663 107.748 107.669 107.693 107.715L107.283 108.412C107.243 108.479 107.234 108.564 107.256 108.641C107.282 108.731 107.35 108.798 107.432 108.816L107.782 108.891V108.906L107.815 108.898L107.851 108.906V108.889L108.147 108.816C108.219 108.798 108.278 108.731 108.301 108.641C108.321 108.564 108.312 108.48 108.278 108.412Z",
    fill: "#98C6CF",
    stroke: "url(#paint468_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.171 109.527H107.385C107.234 109.527 107.106 109.418 107.079 109.269C107.042 109.062 107.201 108.872 107.409 108.872H108.146C108.355 108.872 108.513 109.062 108.477 109.269C108.451 109.418 108.322 109.527 108.171 109.527Z",
    fill: "#98C6CF",
    stroke: "url(#paint469_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.187 109.886H108.369C108.369 109.886 108.171 109.47 107.748 109.5C107.326 109.529 107.187 109.886 107.187 109.886Z",
    fill: "#98C6CF",
    stroke: "url(#paint470_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.278 104.471L107.92 103.774C107.873 103.727 107.837 103.721 107.815 103.726C107.789 103.721 107.748 103.727 107.693 103.774L107.283 104.471C107.243 104.538 107.234 104.622 107.256 104.699C107.282 104.789 107.35 104.856 107.432 104.874L107.782 104.949V104.964L107.815 104.957L107.851 104.964V104.947L108.147 104.874C108.219 104.856 108.278 104.789 108.301 104.699C108.321 104.622 108.312 104.538 108.278 104.471Z",
    fill: "#98C6CF",
    stroke: "url(#paint471_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.171 105.586H107.385C107.234 105.586 107.106 105.477 107.079 105.328C107.042 105.12 107.201 104.931 107.409 104.931H108.146C108.355 104.931 108.513 105.12 108.477 105.328C108.451 105.477 108.322 105.586 108.171 105.586Z",
    fill: "#98C6CF",
    stroke: "url(#paint472_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.187 105.945H108.369C108.369 105.945 108.171 105.528 107.748 105.558C107.326 105.587 107.187 105.945 107.187 105.945Z",
    fill: "#98C6CF",
    stroke: "url(#paint473_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.749 108.412L111.391 107.715C111.344 107.669 111.309 107.663 111.286 107.667C111.259 107.663 111.219 107.669 111.164 107.715L110.754 108.412C110.714 108.479 110.705 108.564 110.727 108.641C110.754 108.731 110.821 108.798 110.904 108.816L111.254 108.891V108.906L111.286 108.898L111.322 108.906V108.889L111.619 108.816C111.69 108.798 111.75 108.731 111.772 108.641C111.792 108.564 111.784 108.48 111.749 108.412Z",
    fill: "#98C6CF",
    stroke: "url(#paint474_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.642 109.527H110.856C110.706 109.527 110.577 109.418 110.55 109.269C110.514 109.062 110.672 108.872 110.881 108.872H111.618C111.827 108.872 111.985 109.062 111.948 109.269C111.922 109.418 111.793 109.527 111.642 109.527Z",
    fill: "#98C6CF",
    stroke: "url(#paint475_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.657 109.886H111.84C111.84 109.886 111.642 109.47 111.219 109.5C110.797 109.529 110.657 109.886 110.657 109.886Z",
    fill: "#98C6CF",
    stroke: "url(#paint476_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.22 108.412L114.862 107.715C114.815 107.669 114.78 107.663 114.757 107.667C114.731 107.663 114.69 107.669 114.635 107.715L114.225 108.412C114.185 108.479 114.175 108.564 114.198 108.641C114.225 108.731 114.292 108.798 114.374 108.816L114.725 108.891V108.906L114.757 108.898L114.793 108.906V108.889L115.089 108.816C115.161 108.798 115.22 108.731 115.243 108.641C115.263 108.564 115.255 108.48 115.22 108.412Z",
    fill: "#98C6CF",
    stroke: "url(#paint477_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.114 109.527H114.327C114.176 109.527 114.048 109.418 114.021 109.269C113.985 109.062 114.143 108.872 114.352 108.872H115.089C115.298 108.872 115.456 109.062 115.419 109.269C115.393 109.418 115.264 109.527 115.114 109.527Z",
    fill: "#98C6CF",
    stroke: "url(#paint478_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.129 109.886H115.312C115.312 109.886 115.114 109.47 114.691 109.5C114.268 109.529 114.129 109.886 114.129 109.886Z",
    fill: "#98C6CF",
    stroke: "url(#paint479_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6553 101.861H82.8457V103.255H86.6553V101.861Z",
    fill: "#98C6CF",
    stroke: "url(#paint480_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3059 103.146H81.1943V104.539H88.3059V103.146Z",
    fill: "#98C6CF",
    stroke: "url(#paint481_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4059 104.731H80.0942V106.125H89.4059V104.731Z",
    fill: "#98C6CF",
    stroke: "url(#paint482_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3231 106.021H79.1777V107.415H90.3231V106.021Z",
    fill: "#98C6CF",
    stroke: "url(#paint483_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1667 107.426H78.3345V108.82H91.1667V107.426Z",
    fill: "#98C6CF",
    stroke: "url(#paint484_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0794 99.7395L84.823 99.2395C84.7889 99.2061 84.7639 99.2015 84.7471 99.2051C84.7282 99.2015 84.6992 99.2061 84.6599 99.2395L84.3654 99.7395C84.3368 99.7877 84.3297 99.8482 84.346 99.9036C84.3649 99.9682 84.4138 100.016 84.4729 100.029L84.7241 100.084V100.094L84.7471 100.089L84.7731 100.094V100.082L84.9856 100.03C85.0371 100.017 85.0794 99.9692 85.0962 99.9041C85.1105 99.8482 85.1043 99.7877 85.0794 99.7395Z",
    fill: "#98C6CF",
    stroke: "url(#paint485_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0024 100.54H84.4382C84.3302 100.54 84.2374 100.462 84.2186 100.355C84.1926 100.206 84.3057 100.07 84.4556 100.07H84.9846C85.1344 100.07 85.248 100.207 85.2215 100.355C85.2032 100.462 85.1105 100.54 85.0024 100.54Z",
    fill: "#98C6CF",
    stroke: "url(#paint486_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2964 100.793H85.1454C85.1454 100.793 85.0033 100.494 84.6995 100.516C84.3963 100.537 84.2964 100.793 84.2964 100.793Z",
    fill: "#98C6CF",
    stroke: "url(#paint487_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2652 100.796C84.2652 100.796 83.8192 101.116 83.9044 101.223C83.9895 101.33 84.2229 101.309 84.2229 101.309L84.1169 101.757H85.3905L85.1994 101.288C85.1994 101.288 85.709 101.288 85.4965 101.074C85.3793 100.956 85.1142 100.796 85.1142 100.796L84.2652 100.796Z",
    fill: "#98C6CF",
    stroke: "url(#paint488_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3718 108.411L78.014 107.714C77.9666 107.668 77.9315 107.662 77.9085 107.666C77.8825 107.662 77.8418 107.668 77.7872 107.714L77.377 108.411C77.3372 108.478 77.327 108.563 77.35 108.64C77.3765 108.73 77.4442 108.797 77.5263 108.815L77.8764 108.89V108.905L77.9085 108.897L77.9452 108.905V108.888L78.2413 108.815C78.3132 108.797 78.3723 108.73 78.3952 108.64C78.4151 108.563 78.4059 108.479 78.3718 108.411Z",
    fill: "#98C6CF",
    stroke: "url(#paint489_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2649 109.526H77.4786C77.3277 109.526 77.1993 109.417 77.1728 109.268C77.1361 109.061 77.2946 108.871 77.503 108.871H78.24C78.4489 108.871 78.6069 109.061 78.5707 109.268C78.5447 109.417 78.4158 109.526 78.2649 109.526Z",
    fill: "#98C6CF",
    stroke: "url(#paint490_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2803 109.885H78.4632C78.4632 109.885 78.2649 109.469 77.8419 109.499C77.4199 109.528 77.2803 109.885 77.2803 109.885Z",
    fill: "#98C6CF",
    stroke: "url(#paint491_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8427 108.411L81.485 107.714C81.4376 107.668 81.4024 107.662 81.3795 107.666C81.3535 107.662 81.3132 107.668 81.2582 107.714L80.8479 108.411C80.8082 108.478 80.7985 108.563 80.8209 108.64C80.8474 108.73 80.9152 108.797 80.9973 108.815L81.3474 108.89V108.905L81.3795 108.897L81.4162 108.905V108.888L81.7123 108.815C81.7841 108.797 81.8433 108.73 81.8662 108.64C81.8861 108.563 81.8774 108.479 81.8427 108.411Z",
    fill: "#98C6CF",
    stroke: "url(#paint492_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7361 109.526H80.9498C80.7994 109.526 80.6705 109.417 80.644 109.268C80.6073 109.061 80.7658 108.871 80.9742 108.871H81.7112C81.9201 108.871 82.0781 109.061 82.0419 109.268C82.0154 109.417 81.8865 109.526 81.7361 109.526Z",
    fill: "#98C6CF",
    stroke: "url(#paint493_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7515 109.885H81.9343C81.9343 109.885 81.7361 109.469 81.3131 109.499C80.8906 109.528 80.7515 109.885 80.7515 109.885Z",
    fill: "#98C6CF",
    stroke: "url(#paint494_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3132 108.411L84.9554 107.714C84.908 107.668 84.8729 107.662 84.8499 107.666C84.8239 107.662 84.7837 107.668 84.7286 107.714L84.3184 108.411C84.2786 108.478 84.2684 108.563 84.2914 108.64C84.3179 108.73 84.3856 108.797 84.4677 108.815L84.8178 108.89V108.905L84.8499 108.897L84.8866 108.905V108.888L85.1827 108.815C85.2546 108.797 85.3137 108.73 85.3366 108.64C85.3565 108.563 85.3478 108.479 85.3132 108.411Z",
    fill: "#98C6CF",
    stroke: "url(#paint495_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2068 109.526H84.4205C84.2696 109.526 84.1412 109.417 84.1147 109.268C84.078 109.061 84.2365 108.871 84.4454 108.871H85.1824C85.3913 108.871 85.5493 109.061 85.5126 109.268C85.4861 109.417 85.3577 109.526 85.2068 109.526Z",
    fill: "#98C6CF",
    stroke: "url(#paint496_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2222 109.885H85.4051C85.4051 109.885 85.2068 109.469 84.7838 109.499C84.3613 109.528 84.2222 109.885 84.2222 109.885Z",
    fill: "#98C6CF",
    stroke: "url(#paint497_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3132 104.466L84.9554 103.769C84.908 103.723 84.8729 103.716 84.8499 103.721C84.8239 103.716 84.7837 103.723 84.7286 103.769L84.3184 104.466C84.2786 104.533 84.2684 104.617 84.2914 104.694C84.3179 104.785 84.3856 104.851 84.4677 104.869L84.8178 104.945V104.959L84.8499 104.952L84.8866 104.959V104.943L85.1827 104.869C85.2546 104.851 85.3137 104.785 85.3366 104.694C85.3565 104.617 85.3478 104.533 85.3132 104.466Z",
    fill: "#98C6CF",
    stroke: "url(#paint498_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2068 105.581H84.4205C84.2696 105.581 84.1412 105.472 84.1147 105.323C84.078 105.116 84.2365 104.926 84.4454 104.926H85.1824C85.3913 104.926 85.5493 105.116 85.5126 105.323C85.4861 105.472 85.3577 105.581 85.2068 105.581Z",
    fill: "#98C6CF",
    stroke: "url(#paint499_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2222 105.94H85.4051C85.4051 105.94 85.2068 105.523 84.7838 105.553C84.3613 105.583 84.2222 105.94 84.2222 105.94Z",
    fill: "#98C6CF",
    stroke: "url(#paint500_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7846 108.411L88.4269 107.714C88.3795 107.668 88.3443 107.662 88.3214 107.666C88.2954 107.662 88.2546 107.668 88.2001 107.714L87.7898 108.411C87.7501 108.478 87.7404 108.563 87.7628 108.64C87.7893 108.73 87.8571 108.797 87.9392 108.815L88.2893 108.89V108.905L88.3214 108.897L88.3581 108.905V108.888L88.6542 108.815C88.726 108.797 88.7852 108.73 88.8081 108.64C88.828 108.563 88.8188 108.479 88.7846 108.411Z",
    fill: "#98C6CF",
    stroke: "url(#paint501_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.678 109.526H87.8917C87.7408 109.526 87.6124 109.417 87.5859 109.268C87.5492 109.061 87.7077 108.871 87.9161 108.871H88.6531C88.862 108.871 89.02 109.061 88.9838 109.268C88.9573 109.417 88.8284 109.526 88.678 109.526Z",
    fill: "#98C6CF",
    stroke: "url(#paint502_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6929 109.885H88.8757C88.8757 109.885 88.6775 109.469 88.2545 109.499C87.8325 109.528 87.6929 109.885 87.6929 109.885Z",
    fill: "#98C6CF",
    stroke: "url(#paint503_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2551 108.411L91.8973 107.714C91.8499 107.668 91.8148 107.662 91.7918 107.666C91.7658 107.662 91.7256 107.668 91.6705 107.714L91.2603 108.411C91.2205 108.478 91.2103 108.563 91.2333 108.64C91.2598 108.73 91.3275 108.797 91.4096 108.815L91.7597 108.89V108.905L91.7918 108.897L91.8285 108.905V108.888L92.1246 108.815C92.1965 108.797 92.2556 108.73 92.2785 108.64C92.2984 108.563 92.2897 108.479 92.2551 108.411Z",
    fill: "#98C6CF",
    stroke: "url(#paint504_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1487 109.526H91.3624C91.212 109.526 91.0831 109.417 91.0566 109.268C91.0199 109.061 91.1784 108.871 91.3873 108.871H92.1243C92.3332 108.871 92.4912 109.061 92.4545 109.268C92.428 109.417 92.2991 109.526 92.1487 109.526Z",
    fill: "#98C6CF",
    stroke: "url(#paint505_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1641 109.885H92.3469C92.3469 109.885 92.1487 109.469 91.7257 109.499C91.3032 109.528 91.1641 109.885 91.1641 109.885Z",
    fill: "#98C6CF",
    stroke: "url(#paint506_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1651 117.554L74.3677 119.754H119.374L116.199 117.489L77.1651 117.554Z",
    fill: "#98C6CF",
    stroke: "url(#paint507_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.259 119.697H74.3394V120.627H119.259V119.697Z",
    fill: "#98C6CF",
    stroke: "url(#paint508_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0034 120.657L77.6292 126.086V137.237H81.3521V125.999L82.4978 120.657H76.0034Z",
    fill: "#98C6CF",
    stroke: "url(#paint509_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0034 120.657L76.3627 122.104H82.2404L82.4978 120.657H76.0034Z",
    fill: "url(#paint510_linear_2761_32788)",
    stroke: "url(#paint511_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6095 139.673H79.4512H79.3197H77.2572L76.6191 140.713V142.403H79.3197H79.4512H82.2181V140.713L81.6095 139.673Z",
    fill: "#98C6CF",
    stroke: "url(#paint512_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3385 137.121H79.4478H79.3321H77.5244L76.9658 138.161V139.851H79.3321H79.4478H81.8716V138.161L81.3385 137.121Z",
    fill: "#98C6CF",
    stroke: "url(#paint513_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3329 142.236H79.4626H79.2872H76.5444L75.6958 142.967V144.153H79.2872H79.4626H83.1417V142.967L82.3329 142.236Z",
    fill: "#98C6CF",
    stroke: "url(#paint514_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.371 120.657L112.996 126.086V137.237H116.719V125.999L117.865 120.657H111.371Z",
    fill: "#98C6CF",
    stroke: "url(#paint515_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.371 120.657L111.729 122.104H117.608L117.865 120.657H111.371Z",
    fill: "url(#paint516_linear_2761_32788)",
    stroke: "url(#paint517_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.977 139.673H114.818H114.687H112.624L111.986 140.713V142.403H114.687H114.818H117.585V140.713L116.977 139.673Z",
    fill: "#98C6CF",
    stroke: "url(#paint518_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.706 137.121H114.814H114.699H112.892L112.333 138.161V139.851H114.699H114.814H117.239V138.161L116.706 137.121Z",
    fill: "#98C6CF",
    stroke: "url(#paint519_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.7 142.236H114.83H114.654H111.911L111.063 142.967V144.153H114.654H114.83H118.508V142.967L117.7 142.236Z",
    fill: "#98C6CF",
    stroke: "url(#paint520_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.632 143.954H5.81201V158.509H188.632V143.954Z",
    fill: "#98C6CF",
    stroke: "url(#paint521_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.741 143.954H40.7031V158.509H153.741V143.954Z",
    fill: "#98C6CF",
    stroke: "url(#paint522_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.647 144.141H78.062L79.7703 138.698H113.938L115.647 144.141Z",
    fill: "#98C6CF",
    stroke: "url(#paint523_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6421 138.943H114.092",
    stroke: "url(#paint524_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3979 139.747H114.335",
    stroke: "url(#paint525_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1538 140.562H114.579",
    stroke: "url(#paint526_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9097 141.376H114.824",
    stroke: "url(#paint527_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.666 142.185H115.067",
    stroke: "url(#paint528_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4219 142.989H115.311",
    stroke: "url(#paint529_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8416 99.4658H94.8154V100.939H98.8416V99.4658Z",
    fill: "#98C6CF",
    stroke: "url(#paint530_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.587 100.812H93.0708V102.286H100.587V100.812Z",
    fill: "#98C6CF",
    stroke: "url(#paint531_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75 102.488H91.9082V103.962H101.75V102.488Z",
    fill: "#98C6CF",
    stroke: "url(#paint532_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.718 103.855H90.939V105.329H102.718V103.855Z",
    fill: "#98C6CF",
    stroke: "url(#paint533_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.609 105.338H90.0474V106.811H103.609V105.338Z",
    fill: "#98C6CF",
    stroke: "url(#paint534_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 108.053H87.6455V110.07H106.011V108.053Z",
    fill: "#98C6CF",
    stroke: "url(#paint535_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 110.041H87.6455V112.058H106.011V110.041Z",
    fill: "#98C6CF",
    stroke: "url(#paint536_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 112.035H87.6455V114.052H106.011V112.035Z",
    fill: "#98C6CF",
    stroke: "url(#paint537_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.011 114.024H87.6455V116.041H106.011V114.024Z",
    fill: "#98C6CF",
    stroke: "url(#paint538_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1769 97.218L96.9057 96.6898C96.8695 96.6544 96.843 96.6498 96.8257 96.6534C96.8058 96.6498 96.7753 96.6544 96.734 96.6898L96.4226 97.218C96.3925 97.2693 96.3849 97.3334 96.4022 97.3913C96.4226 97.4595 96.4735 97.5103 96.5362 97.5241L96.8018 97.5816V97.5928L96.8262 97.5867L96.8537 97.5928V97.58L97.0785 97.5246C97.133 97.5113 97.1779 97.4605 97.1952 97.3918C97.2095 97.3334 97.2028 97.2693 97.1769 97.218Z",
    fill: "#98C6CF",
    stroke: "url(#paint539_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0958 98.0677H96.4995C96.3854 98.0677 96.2875 97.9851 96.2676 97.8723C96.2401 97.7154 96.3599 97.5713 96.5184 97.5713H97.0774C97.2359 97.5713 97.3557 97.7154 97.3282 97.8723C97.3078 97.9851 97.2099 98.0677 97.0958 98.0677Z",
    fill: "#98C6CF",
    stroke: "url(#paint540_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3491 98.3404H97.2466C97.2466 98.3404 97.0963 98.0245 96.7757 98.0471C96.4546 98.0696 96.3491 98.3404 96.3491 98.3404Z",
    fill: "#98C6CF",
    stroke: "url(#paint541_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3159 98.3379C96.3159 98.3379 95.845 98.6764 95.9347 98.7892C96.0244 98.902 96.2711 98.8794 96.2711 98.8794L96.1589 99.3533H97.5049L97.3031 98.8569C97.3031 98.8569 97.8413 98.8569 97.617 98.6312C97.4932 98.5066 97.2134 98.3379 97.2134 98.3379H96.3159Z",
    fill: "#98C6CF",
    stroke: "url(#paint542_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0871 106.388L89.709 105.652C89.6585 105.603 89.6218 105.596 89.5974 105.601C89.5698 105.596 89.527 105.603 89.4694 105.652L89.0357 106.388C88.9939 106.46 88.9832 106.549 89.0072 106.63C89.0352 106.725 89.1066 106.796 89.1937 106.814L89.5637 106.894V106.91L89.5974 106.902L89.6361 106.91V106.892L89.949 106.815C90.025 106.796 90.0871 106.726 90.1116 106.63C90.133 106.549 90.1238 106.46 90.0871 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint543_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9744 107.571H89.1437C88.9846 107.571 88.8481 107.456 88.8205 107.298C88.7818 107.08 88.949 106.879 89.1702 106.879H89.9489C90.1696 106.879 90.3367 107.08 90.2985 107.298C90.27 107.456 90.1339 107.571 89.9744 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint544_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9336 107.946H90.1837C90.1837 107.946 89.9743 107.506 89.5273 107.538C89.0809 107.569 88.9336 107.946 88.9336 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint545_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7556 106.388L93.3774 105.652C93.327 105.603 93.2903 105.596 93.2658 105.601C93.2383 105.596 93.1955 105.603 93.1379 105.652L92.7042 106.388C92.6624 106.46 92.6517 106.549 92.6757 106.63C92.7037 106.725 92.775 106.796 92.8622 106.814L93.2322 106.894V106.91L93.2658 106.902L93.3045 106.91V106.892L93.6175 106.815C93.6934 106.796 93.7556 106.726 93.78 106.63C93.8014 106.549 93.7923 106.46 93.7556 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint546_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6428 107.571H92.8116C92.6526 107.571 92.5165 107.456 92.4885 107.298C92.4498 107.08 92.6169 106.879 92.8376 106.879H93.6163C93.837 106.879 94.0042 107.08 93.9654 107.298C93.9384 107.456 93.8019 107.571 93.6428 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint547_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6021 107.946H93.8522C93.8522 107.946 93.6427 107.506 93.1958 107.538C92.7493 107.569 92.6021 107.946 92.6021 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint548_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.424 106.388L97.0459 105.652C96.9954 105.603 96.9587 105.596 96.9343 105.601C96.9067 105.596 96.8639 105.603 96.8064 105.652L96.3727 106.388C96.3309 106.46 96.3202 106.549 96.3441 106.63C96.3721 106.725 96.4435 106.796 96.5306 106.814L96.9006 106.894V106.91L96.9343 106.902L96.973 106.91V106.892L97.2859 106.815C97.3619 106.796 97.424 106.726 97.4485 106.63C97.4699 106.549 97.4607 106.46 97.424 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint549_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3113 107.571H96.4801C96.3211 107.571 96.1845 107.456 96.157 107.298C96.1182 107.08 96.2854 106.879 96.5066 106.879H97.2853C97.506 106.879 97.6731 107.08 97.6349 107.298C97.6069 107.456 97.4703 107.571 97.3113 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint550_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2705 107.946H97.5207C97.5207 107.946 97.3112 107.506 96.8642 107.538C96.4178 107.569 96.2705 107.946 96.2705 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint551_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.424 102.212L97.0459 101.476C96.9954 101.427 96.9587 101.421 96.9343 101.425C96.9067 101.42 96.8639 101.427 96.8064 101.476L96.3727 102.212C96.3309 102.284 96.3202 102.373 96.3441 102.454C96.3721 102.549 96.4435 102.62 96.5306 102.639L96.9006 102.719V102.735L96.9343 102.726L96.973 102.735V102.717L97.2859 102.639C97.3619 102.62 97.424 102.55 97.4485 102.455C97.4699 102.373 97.4607 102.284 97.424 102.212Z",
    fill: "#98C6CF",
    stroke: "url(#paint552_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3113 103.395H96.4801C96.3211 103.395 96.1845 103.28 96.157 103.123C96.1182 102.904 96.2854 102.703 96.5066 102.703H97.2853C97.506 102.703 97.6731 102.904 97.6349 103.123C97.6069 103.28 97.4703 103.395 97.3113 103.395Z",
    fill: "#98C6CF",
    stroke: "url(#paint553_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2705 103.771H97.5207C97.5207 103.771 97.3112 103.33 96.8642 103.362C96.4178 103.393 96.2705 103.771 96.2705 103.771Z",
    fill: "#98C6CF",
    stroke: "url(#paint554_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.093 106.388L100.714 105.652C100.664 105.603 100.627 105.596 100.603 105.601C100.575 105.596 100.532 105.603 100.475 105.652L100.041 106.388C99.9993 106.46 99.9886 106.549 100.013 106.63C100.041 106.725 100.112 106.796 100.199 106.814L100.569 106.894V106.91L100.603 106.902L100.641 106.91V106.892L100.954 106.815C101.03 106.796 101.092 106.726 101.117 106.63C101.138 106.549 101.129 106.46 101.093 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint555_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.98 107.571H100.149C99.9895 107.571 99.8535 107.456 99.8254 107.298C99.7867 107.08 99.9539 106.879 100.175 106.879H100.953C101.174 106.879 101.341 107.08 101.302 107.298C101.275 107.456 101.139 107.571 100.98 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint556_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.939 107.946H101.189C101.189 107.946 100.98 107.506 100.533 107.538C100.086 107.569 99.939 107.946 99.939 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint557_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.761 106.388L104.383 105.652C104.332 105.603 104.296 105.596 104.271 105.601C104.244 105.596 104.201 105.603 104.143 105.652L103.71 106.388C103.668 106.46 103.657 106.549 103.681 106.63C103.709 106.725 103.78 106.796 103.868 106.814L104.238 106.894V106.91L104.271 106.902L104.31 106.91V106.892L104.623 106.815C104.699 106.796 104.761 106.726 104.785 106.63C104.807 106.549 104.798 106.46 104.761 106.388Z",
    fill: "#98C6CF",
    stroke: "url(#paint558_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.648 107.571H103.817C103.658 107.571 103.522 107.456 103.494 107.298C103.456 107.08 103.623 106.879 103.844 106.879H104.623C104.843 106.879 105.011 107.08 104.972 107.298C104.943 107.456 104.807 107.571 104.648 107.571Z",
    fill: "#98C6CF",
    stroke: "url(#paint559_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.607 107.946H104.858C104.858 107.946 104.648 107.506 104.201 107.538C103.755 107.569 103.607 107.946 103.607 107.946Z",
    fill: "#98C6CF",
    stroke: "url(#paint560_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6454 116.039L84.689 118.365H109.151L105.796 115.971L87.6454 116.039Z",
    fill: "#98C6CF",
    stroke: "url(#paint561_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.029 118.305H84.8721V119.287H109.029V118.305Z",
    fill: "#98C6CF",
    stroke: "url(#paint562_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3345 119.396L88.1361 125.06V136.845H92.071V124.967L93.3415 119.396H86.3345Z",
    fill: "#98C6CF",
    stroke: "url(#paint563_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3345 119.396L86.6933 120.525H93.0842L93.3415 119.396H86.3345Z",
    fill: "url(#paint564_linear_2761_32788)",
    stroke: "url(#paint565_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3432 139.424H90.062H89.9229H87.7426L87.0684 140.523V142.309H89.9229H90.062H92.9858V140.523L92.3432 139.424Z",
    fill: "#98C6CF",
    stroke: "url(#paint566_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0565 136.72H90.0577H89.9354H88.0253L87.4346 137.819V139.605H89.9354H90.0577H92.6197V137.819L92.0565 136.72Z",
    fill: "#98C6CF",
    stroke: "url(#paint567_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.107 142.123H90.0736H89.8881H86.9887L86.0923 142.895V144.149H89.8881H90.0736H93.9617V142.895L93.107 142.123Z",
    fill: "#98C6CF",
    stroke: "url(#paint568_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.609 119.396L102.41 125.06V136.845H106.345V124.967L107.616 119.396H100.609Z",
    fill: "#98C6CF",
    stroke: "url(#paint569_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.609 119.396L100.968 120.525H107.359L107.616 119.396H100.609Z",
    fill: "url(#paint570_linear_2761_32788)",
    stroke: "url(#paint571_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.618 139.43H104.336H104.197H102.017L101.343 140.529V142.315H104.197H104.336H107.26V140.529L106.618 139.43Z",
    fill: "#98C6CF",
    stroke: "url(#paint572_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.331 136.726H104.332H104.21H102.3L101.709 137.825V139.611H104.21H104.332H106.894V137.825L106.331 136.726Z",
    fill: "#98C6CF",
    stroke: "url(#paint573_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.381 142.128H104.348H104.163H101.264L100.367 142.9V144.154H104.163H104.348H108.236V142.9L107.381 142.128Z",
    fill: "#98C6CF",
    stroke: "url(#paint574_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6128 144.398H124.279",
    stroke: "url(#paint575_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5654 145.155H124.297",
    stroke: "url(#paint576_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5186 145.907H124.315",
    stroke: "url(#paint577_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4717 146.664H124.333",
    stroke: "url(#paint578_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4248 147.421H124.351",
    stroke: "url(#paint579_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3774 148.173H124.369",
    stroke: "url(#paint580_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.354 148.548H124.378",
    stroke: "url(#paint581_linear_2761_32788)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2442 148.565H67.5132L67.8791 146.507L67.5132 143.954H72.2442L71.8783 146.507L72.2442 148.565Z",
    fill: "#98C6CF",
    stroke: "url(#paint582_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.954 148.565H121.222L121.589 146.507L121.222 143.954H125.954L125.587 146.507L125.954 148.565Z",
    fill: "#98C6CF",
    stroke: "url(#paint583_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.551 148.303H64.1562V158.436H129.551V148.303Z",
    fill: "#98C6CF",
    stroke: "url(#paint584_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.853 148.684H130.073",
    stroke: "url(#paint585_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8135 149.853H130.087",
    stroke: "url(#paint586_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7744 151.027H130.103",
    stroke: "url(#paint587_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7354 152.191H130.118",
    stroke: "url(#paint588_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6963 153.355H130.133",
    stroke: "url(#paint589_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6572 154.53H130.148",
    stroke: "url(#paint590_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6182 155.699H130.163",
    stroke: "url(#paint591_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5786 156.868H130.178",
    stroke: "url(#paint592_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5396 158.032H130.193",
    stroke: "url(#paint593_linear_2761_32788)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5297 148.428H60.6758V158.436H64.5297V148.428Z",
    fill: "#98C6CF",
    stroke: "url(#paint594_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.405 151.683H60.7993C60.5934 151.683 60.4263 151.515 60.4263 151.308C60.4263 151.101 60.5934 150.933 60.7993 150.933H64.405C64.6109 150.933 64.7781 151.101 64.7781 151.308C64.7781 151.515 64.6109 151.683 64.405 151.683Z",
    fill: "#98C6CF",
    stroke: "url(#paint595_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.405 148.928H60.7993C60.5934 148.928 60.4263 148.759 60.4263 148.552C60.4263 148.345 60.5934 148.177 60.7993 148.177H64.405C64.6109 148.177 64.7781 148.345 64.7781 148.552C64.7781 148.759 64.6109 148.928 64.405 148.928Z",
    fill: "#98C6CF",
    stroke: "url(#paint596_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4672 153.928H60.7376C60.5659 153.928 60.4268 153.788 60.4268 153.616C60.4268 153.443 60.5659 153.303 60.7376 153.303H64.4672C64.6389 153.303 64.7781 153.443 64.7781 153.616C64.7781 153.788 64.6389 153.928 64.4672 153.928Z",
    fill: "#98C6CF",
    stroke: "url(#paint597_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.344 148.428H129.49V158.436H133.344V148.428Z",
    fill: "#98C6CF",
    stroke: "url(#paint598_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.219 151.683H129.614C129.408 151.683 129.241 151.515 129.241 151.308C129.241 151.101 129.408 150.933 129.614 150.933H133.219C133.425 150.933 133.593 151.101 133.593 151.308C133.593 151.515 133.426 151.683 133.219 151.683Z",
    fill: "#98C6CF",
    stroke: "url(#paint599_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.219 148.928H129.614C129.408 148.928 129.241 148.759 129.241 148.552C129.241 148.345 129.408 148.177 129.614 148.177H133.219C133.425 148.177 133.593 148.345 133.593 148.552C133.593 148.759 133.426 148.928 133.219 148.928Z",
    fill: "#98C6CF",
    stroke: "url(#paint600_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.282 153.928H129.552C129.38 153.928 129.241 153.788 129.241 153.616C129.241 153.443 129.38 153.303 129.552 153.303H133.282C133.453 153.303 133.593 153.443 133.593 153.616C133.593 153.788 133.453 153.928 133.282 153.928Z",
    fill: "#98C6CF",
    stroke: "url(#paint601_linear_2761_32788)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2761_32788",
    x1: 30.4025,
    y1: 99.4658,
    x2: 27.9793,
    y2: 103.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2761_32788",
    x1: 33.0227,
    y1: 100.813,
    x2: 31.3751,
    y2: 105.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2761_32788",
    x1: 34.7684,
    y1: 102.488,
    x2: 33.4506,
    y2: 107.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2761_32788",
    x1: 36.2225,
    y1: 103.855,
    x2: 35.099,
    y2: 108.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2761_32788",
    x1: 37.5605,
    y1: 105.338,
    x2: 36.5732,
    y2: 110.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2761_32788",
    x1: 41.1666,
    y1: 108.053,
    x2: 39.8015,
    y2: 115.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2761_32788",
    x1: 41.1666,
    y1: 110.041,
    x2: 39.8015,
    y2: 117.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2761_32788",
    x1: 41.1666,
    y1: 112.035,
    x2: 39.8015,
    y2: 119.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2761_32788",
    x1: 41.1666,
    y1: 114.024,
    x2: 39.8015,
    y2: 121.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2761_32788",
    x1: 27.9577,
    y1: 96.6523,
    x2: 26.6305,
    y2: 97.2949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2761_32788",
    x1: 28.1511,
    y1: 97.5713,
    x2: 27.274,
    y2: 98.6322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2761_32788",
    x1: 28.0233,
    y1: 98.0459,
    x2: 27.5621,
    y2: 98.8362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2761_32788",
    x1: 28.6622,
    y1: 98.3379,
    x2: 26.8366,
    y2: 100.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2761_32788",
    x1: 20.9575,
    y1: 105.6,
    x2: 19.1083,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2761_32788",
    x1: 21.2273,
    y1: 106.879,
    x2: 20.0051,
    y2: 108.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2761_32788",
    x1: 21.0488,
    y1: 107.536,
    x2: 20.4061,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2761_32788",
    x1: 24.626,
    y1: 105.6,
    x2: 22.7768,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2761_32788",
    x1: 24.8969,
    y1: 106.879,
    x2: 23.6748,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2761_32788",
    x1: 24.7179,
    y1: 107.536,
    x2: 24.0753,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2761_32788",
    x1: 28.2944,
    y1: 105.6,
    x2: 26.4452,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2761_32788",
    x1: 28.5649,
    y1: 106.879,
    x2: 27.3427,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2761_32788",
    x1: 28.3858,
    y1: 107.536,
    x2: 27.743,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2761_32788",
    x1: 28.2944,
    y1: 101.424,
    x2: 26.4452,
    y2: 102.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2761_32788",
    x1: 28.5649,
    y1: 102.703,
    x2: 27.3427,
    y2: 104.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2761_32788",
    x1: 28.3858,
    y1: 103.36,
    x2: 27.743,
    y2: 104.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2761_32788",
    x1: 31.9629,
    y1: 105.6,
    x2: 30.1137,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2761_32788",
    x1: 32.2332,
    y1: 106.879,
    x2: 31.011,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2761_32788",
    x1: 32.0542,
    y1: 107.536,
    x2: 31.4114,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2761_32788",
    x1: 35.6314,
    y1: 105.6,
    x2: 33.7821,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2761_32788",
    x1: 35.9023,
    y1: 106.879,
    x2: 34.6802,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2761_32788",
    x1: 35.7227,
    y1: 107.536,
    x2: 35.0799,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2761_32788",
    x1: 45.8344,
    y1: 115.971,
    x2: 44.379,
    y2: 124.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2761_32788",
    x1: 45.6357,
    y1: 118.305,
    x2: 45.3816,
    y2: 121.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2761_32788",
    x1: 25.6641,
    y1: 119.349,
    x2: 12.1426,
    y2: 122.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2761_32788",
    x1: 25.6641,
    y1: 119.349,
    x2: 24.0023,
    y2: 123.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2761_32788",
    x1: 25.6641,
    y1: 119.349,
    x2: 24.0023,
    y2: 123.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2761_32788",
    x1: 24.471,
    y1: 136.721,
    x2: 19.2815,
    y2: 141.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2761_32788",
    x1: 25.0207,
    y1: 139.419,
    x2: 19.8833,
    y2: 145.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2761_32788",
    x1: 26.4858,
    y1: 142.117,
    x2: 23.7266,
    y2: 148.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2761_32788",
    x1: 45.5233,
    y1: 119.349,
    x2: 25.6717,
    y2: 126.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2761_32788",
    x1: 45.5233,
    y1: 119.349,
    x2: 44.3878,
    y2: 124.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2761_32788",
    x1: 45.5233,
    y1: 119.349,
    x2: 44.3878,
    y2: 124.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2761_32788",
    x1: 43.6872,
    y1: 136.721,
    x2: 39.0846,
    y2: 144.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2761_32788",
    x1: 44.5832,
    y1: 139.419,
    x2: 40.2813,
    y2: 147.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2761_32788",
    x1: 46.9735,
    y1: 142.117,
    x2: 45.0768,
    y2: 148.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2761_32788",
    x1: 164.613,
    y1: 100.933,
    x2: 167.036,
    y2: 97.2092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2761_32788",
    x1: 161.994,
    y1: 102.284,
    x2: 163.642,
    y2: 97.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2761_32788",
    x1: 160.248,
    y1: 103.966,
    x2: 161.566,
    y2: 99.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2761_32788",
    x1: 158.794,
    y1: 105.328,
    x2: 159.917,
    y2: 100.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2761_32788",
    x1: 157.456,
    y1: 106.811,
    x2: 158.443,
    y2: 101.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2761_32788",
    x1: 153.85,
    y1: 110.067,
    x2: 155.215,
    y2: 103.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2761_32788",
    x1: 153.85,
    y1: 112.062,
    x2: 155.215,
    y2: 105.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2761_32788",
    x1: 153.85,
    y1: 114.056,
    x2: 155.215,
    y2: 107.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2761_32788",
    x1: 153.85,
    y1: 116.044,
    x2: 155.215,
    y2: 109.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2761_32788",
    x1: 168.274,
    y1: 96.6523,
    x2: 166.947,
    y2: 97.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2761_32788",
    x1: 168.468,
    y1: 97.5713,
    x2: 167.591,
    y2: 98.6322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2761_32788",
    x1: 168.341,
    y1: 98.0459,
    x2: 167.879,
    y2: 98.8362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2761_32788",
    x1: 168.979,
    y1: 98.3379,
    x2: 167.154,
    y2: 100.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2761_32788",
    x1: 175.752,
    y1: 105.6,
    x2: 173.903,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2761_32788",
    x1: 176.023,
    y1: 106.879,
    x2: 174.801,
    y2: 108.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2761_32788",
    x1: 175.844,
    y1: 107.536,
    x2: 175.201,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2761_32788",
    x1: 172.084,
    y1: 105.6,
    x2: 170.235,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2761_32788",
    x1: 172.354,
    y1: 106.879,
    x2: 171.132,
    y2: 108.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2761_32788",
    x1: 172.175,
    y1: 107.536,
    x2: 171.533,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2761_32788",
    x1: 168.416,
    y1: 105.6,
    x2: 166.567,
    y2: 106.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2761_32788",
    x1: 168.686,
    y1: 106.879,
    x2: 167.464,
    y2: 108.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2761_32788",
    x1: 168.507,
    y1: 107.536,
    x2: 167.864,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2761_32788",
    x1: 168.416,
    y1: 101.424,
    x2: 166.567,
    y2: 102.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2761_32788",
    x1: 168.686,
    y1: 102.703,
    x2: 167.464,
    y2: 104.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2761_32788",
    x1: 168.507,
    y1: 103.36,
    x2: 167.864,
    y2: 104.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2761_32788",
    x1: 164.748,
    y1: 105.6,
    x2: 162.898,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2761_32788",
    x1: 165.018,
    y1: 106.879,
    x2: 163.795,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2761_32788",
    x1: 164.839,
    y1: 107.536,
    x2: 164.196,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2761_32788",
    x1: 161.079,
    y1: 105.6,
    x2: 159.23,
    y2: 106.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2761_32788",
    x1: 161.349,
    y1: 106.879,
    x2: 160.127,
    y2: 108.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2761_32788",
    x1: 161.17,
    y1: 107.536,
    x2: 160.528,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2761_32788",
    x1: 185.906,
    y1: 115.971,
    x2: 184.451,
    y2: 124.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2761_32788",
    x1: 149.38,
    y1: 119.291,
    x2: 149.635,
    y2: 115.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2761_32788",
    x1: 179.899,
    y1: 119.349,
    x2: 166.377,
    y2: 122.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2761_32788",
    x1: 179.899,
    y1: 119.349,
    x2: 178.237,
    y2: 123.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2761_32788",
    x1: 179.899,
    y1: 119.349,
    x2: 178.237,
    y2: 123.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2761_32788",
    x1: 178.33,
    y1: 136.721,
    x2: 173.14,
    y2: 141.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2761_32788",
    x1: 178.88,
    y1: 139.419,
    x2: 173.742,
    y2: 145.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2761_32788",
    x1: 180.345,
    y1: 142.117,
    x2: 177.585,
    y2: 148.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2761_32788",
    x1: 166.084,
    y1: 119.349,
    x2: 146.233,
    y2: 126.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2761_32788",
    x1: 166.084,
    y1: 119.349,
    x2: 164.949,
    y2: 124.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2761_32788",
    x1: 166.084,
    y1: 119.349,
    x2: 164.949,
    y2: 124.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2761_32788",
    x1: 164.028,
    y1: 136.721,
    x2: 159.426,
    y2: 144.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2761_32788",
    x1: 164.925,
    y1: 139.419,
    x2: 160.623,
    y2: 147.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2761_32788",
    x1: 167.315,
    y1: 142.117,
    x2: 165.419,
    y2: 148.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2761_32788",
    x1: 65.2504,
    y1: 141.981,
    x2: 64.5883,
    y2: 145.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2761_32788",
    x1: 50.7975,
    y1: 142.357,
    x2: 50.1592,
    y2: 145.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2761_32788",
    x1: 145.002,
    y1: 92.5234,
    x2: 143.207,
    y2: 107.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2761_32788",
    x1: 84.3962,
    y1: 72.041,
    x2: 72.809,
    y2: 86.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2761_32788",
    x1: 81.0439,
    y1: 72.041,
    x2: 69.3363,
    y2: 82.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2761_32788",
    x1: 77.2985,
    y1: 72.041,
    x2: 68.7001,
    y2: 75.7368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2761_32788",
    x1: 84.3499,
    y1: 78.623,
    x2: 82.7973,
    y2: 85.1795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2761_32788",
    x1: 84.3461,
    y1: 77.2969,
    x2: 83.7371,
    y2: 81.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2761_32788",
    x1: 84.3499,
    y1: 80.4033,
    x2: 83.7421,
    y2: 84.5748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2761_32788",
    x1: 85.1088,
    y1: 81.4365,
    x2: 82.4077,
    y2: 90.8291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2761_32788",
    x1: 69.0481,
    y1: 76.5039,
    x2: 67.1179,
    y2: 77.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2761_32788",
    x1: 79.1843,
    y1: 76.5039,
    x2: 77.2542,
    y2: 77.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2761_32788",
    x1: 74.4159,
    y1: 67.4941,
    x2: 72.1102,
    y2: 68.6105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2761_32788",
    x1: 74.7536,
    y1: 69.0859,
    x2: 73.2288,
    y2: 70.9303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2761_32788",
    x1: 74.5305,
    y1: 69.9053,
    x2: 73.7279,
    y2: 71.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2761_32788",
    x1: 75.6417,
    y1: 70.4229,
    x2: 72.4682,
    y2: 73.4952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2761_32788",
    x1: 74.5968,
    y1: 72.1914,
    x2: 72.5896,
    y2: 72.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2761_32788",
    x1: 72.7448,
    y1: 84.2656,
    x2: 58.9612,
    y2: 88.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2761_32788",
    x1: 72.7448,
    y1: 84.2656,
    x2: 71.2033,
    y2: 88.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2761_32788",
    x1: 72.7448,
    y1: 84.2656,
    x2: 71.2033,
    y2: 88.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2761_32788",
    x1: 86.196,
    y1: 84.2656,
    x2: 72.4123,
    y2: 88.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2761_32788",
    x1: 86.196,
    y1: 84.2656,
    x2: 84.6545,
    y2: 88.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2761_32788",
    x1: 86.196,
    y1: 84.2656,
    x2: 84.6545,
    y2: 88.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2761_32788",
    x1: 165.734,
    y1: 81.7334,
    x2: 148.666,
    y2: 107.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2761_32788",
    x1: 159.257,
    y1: 81.7334,
    x2: 140.683,
    y2: 101.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2761_32788",
    x1: 152.019,
    y1: 81.7334,
    x2: 136.642,
    y2: 89.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2761_32788",
    x1: 165.645,
    y1: 92.0791,
    x2: 163.63,
    y2: 102.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2761_32788",
    x1: 146.069,
    y1: 72.9482,
    x2: 142.45,
    y2: 74.7008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2761_32788",
    x1: 146.598,
    y1: 75.4482,
    x2: 144.206,
    y2: 78.3429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2761_32788",
    x1: 146.248,
    y1: 76.7432,
    x2: 144.989,
    y2: 78.8991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2761_32788",
    x1: 147.891,
    y1: 77.542,
    x2: 142.913,
    y2: 82.2791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2761_32788",
    x1: 145.633,
    y1: 81.9785,
    x2: 143.616,
    y2: 82.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2761_32788",
    x1: 153.942,
    y1: 80.3184,
    x2: 151.43,
    y2: 87.7076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2761_32788",
    x1: 171.488,
    y1: 95.2217,
    x2: 171.104,
    y2: 100.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2761_32788",
    x1: 135.231,
    y1: 90.6807,
    x2: 130.899,
    y2: 91.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2761_32788",
    x1: 145.967,
    y1: 90.6807,
    x2: 141.635,
    y2: 91.9237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2761_32788",
    x1: 157.069,
    y1: 90.6807,
    x2: 152.737,
    y2: 91.9237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2761_32788",
    x1: 132.515,
    y1: 72.041,
    x2: 120.928,
    y2: 86.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2761_32788",
    x1: 129.163,
    y1: 72.041,
    x2: 117.455,
    y2: 82.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2761_32788",
    x1: 125.417,
    y1: 72.041,
    x2: 116.819,
    y2: 75.7368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2761_32788",
    x1: 110.805,
    y1: 80.5488,
    x2: 112.358,
    y2: 73.9924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2761_32788",
    x1: 132.483,
    y1: 77.2969,
    x2: 131.874,
    y2: 81.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2761_32788",
    x1: 110.805,
    y1: 81.5928,
    x2: 111.413,
    y2: 77.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2761_32788",
    x1: 136.29,
    y1: 81.4365,
    x2: 133.589,
    y2: 90.8291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2761_32788",
    x1: 127.687,
    y1: 76.5039,
    x2: 125.757,
    y2: 77.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2761_32788",
    x1: 117.551,
    y1: 76.5039,
    x2: 115.62,
    y2: 77.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2761_32788",
    x1: 122.852,
    y1: 67.4941,
    x2: 120.546,
    y2: 68.6107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2761_32788",
    x1: 123.19,
    y1: 69.0859,
    x2: 121.665,
    y2: 70.9304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2761_32788",
    x1: 122.966,
    y1: 69.9053,
    x2: 122.164,
    y2: 71.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2761_32788",
    x1: 124.077,
    y1: 70.4229,
    x2: 120.903,
    y2: 73.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2761_32788",
    x1: 123.06,
    y1: 72.1914,
    x2: 121.053,
    y2: 72.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2761_32788",
    x1: 133.813,
    y1: 84.2656,
    x2: 120.029,
    y2: 88.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2761_32788",
    x1: 133.813,
    y1: 84.2656,
    x2: 132.271,
    y2: 88.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2761_32788",
    x1: 133.813,
    y1: 84.2656,
    x2: 132.271,
    y2: 88.8816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2761_32788",
    x1: 120.362,
    y1: 84.2656,
    x2: 106.577,
    y2: 88.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2761_32788",
    x1: 120.362,
    y1: 84.2656,
    x2: 118.82,
    y2: 88.8817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2761_32788",
    x1: 120.362,
    y1: 84.2656,
    x2: 118.82,
    y2: 88.8817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2761_32788",
    x1: 71.7282,
    y1: 81.7334,
    x2: 54.6605,
    y2: 107.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2761_32788",
    x1: 65.2514,
    y1: 81.7334,
    x2: 46.6778,
    y2: 101.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2761_32788",
    x1: 58.0141,
    y1: 81.7334,
    x2: 42.6366,
    y2: 89.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2761_32788",
    x1: 71.6391,
    y1: 92.0791,
    x2: 69.6235,
    y2: 102.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2761_32788",
    x1: 52.0636,
    y1: 72.9482,
    x2: 48.4449,
    y2: 74.7006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2761_32788",
    x1: 52.5935,
    y1: 75.4482,
    x2: 50.2008,
    y2: 78.3429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2761_32788",
    x1: 52.244,
    y1: 76.7432,
    x2: 50.985,
    y2: 78.8993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2761_32788",
    x1: 53.8867,
    y1: 77.542,
    x2: 48.9087,
    y2: 82.2797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2761_32788",
    x1: 51.6281,
    y1: 81.9785,
    x2: 49.6116,
    y2: 82.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2761_32788",
    x1: 59.937,
    y1: 80.3184,
    x2: 57.425,
    y2: 87.7076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2761_32788",
    x1: 74.4309,
    y1: 95.2217,
    x2: 74.0195,
    y2: 100.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2761_32788",
    x1: 41.2261,
    y1: 90.6807,
    x2: 36.8932,
    y2: 91.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2761_32788",
    x1: 51.9624,
    y1: 90.6807,
    x2: 47.6295,
    y2: 91.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2761_32788",
    x1: 63.0643,
    y1: 90.6807,
    x2: 58.7322,
    y2: 91.9237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2761_32788",
    x1: 70.9022,
    y1: 93.625,
    x2: 69.0426,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2761_32788",
    x1: 72.8549,
    y1: 93.625,
    x2: 70.9952,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2761_32788",
    x1: 74.8065,
    y1: 93.625,
    x2: 72.9469,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2761_32788",
    x1: 76.7592,
    y1: 93.625,
    x2: 74.8995,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2761_32788",
    x1: 78.7103,
    y1: 93.625,
    x2: 76.8507,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2761_32788",
    x1: 117.874,
    y1: 93.625,
    x2: 116.015,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2761_32788",
    x1: 119.827,
    y1: 93.625,
    x2: 117.967,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2761_32788",
    x1: 121.779,
    y1: 93.625,
    x2: 119.919,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2761_32788",
    x1: 123.731,
    y1: 93.625,
    x2: 121.871,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2761_32788",
    x1: 125.683,
    y1: 93.625,
    x2: 123.823,
    y2: 94.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2761_32788",
    x1: 199.881,
    y1: 99.0947,
    x2: 190.157,
    y2: 150.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2761_32788",
    x1: 181.773,
    y1: 99.0947,
    x2: 170.152,
    y2: 148.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2761_32788",
    x1: 88.7673,
    y1: 118.961,
    x2: 42.867,
    y2: 158.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2761_32788",
    x1: 53.8291,
    y1: 119.655,
    x2: 51.509,
    y2: 126.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2761_32788",
    x1: 55.8444,
    y1: 121.796,
    x2: 29.2809,
    y2: 131.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2761_32788",
    x1: 44.4577,
    y1: 120.517,
    x2: 42.4364,
    y2: 120.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2761_32788",
    x1: 48.1497,
    y1: 136.291,
    x2: 45.0138,
    y2: 137.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2761_32788",
    x1: 67.6157,
    y1: 119.655,
    x2: 65.2956,
    y2: 126.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2761_32788",
    x1: 69.6311,
    y1: 121.796,
    x2: 43.067,
    y2: 131.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2761_32788",
    x1: 58.2443,
    y1: 120.517,
    x2: 56.223,
    y2: 120.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2761_32788",
    x1: 61.9357,
    y1: 136.291,
    x2: 58.8005,
    y2: 137.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2761_32788",
    x1: 64.8458,
    y1: 140.227,
    x2: 64.1401,
    y2: 143.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2761_32788",
    x1: 51.2641,
    y1: 141.35,
    x2: 50.618,
    y2: 144.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2761_32788",
    x1: 86.0733,
    y1: 135.456,
    x2: 85.9027,
    y2: 139.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2761_32788",
    x1: 86.0733,
    y1: 134.167,
    x2: 85.9027,
    y2: 137.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2761_32788",
    x1: 86.0733,
    y1: 132.883,
    x2: 85.9027,
    y2: 136.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2761_32788",
    x1: 68.7638,
    y1: 120.084,
    x2: 66.7425,
    y2: 120.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2761_32788",
    x1: 76.157,
    y1: 124.959,
    x2: 69.1802,
    y2: 128.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2761_32788",
    x1: 70.3425,
    y1: 124.839,
    x2: 68.6703,
    y2: 125.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2761_32788",
    x1: 76.9314,
    y1: 124.839,
    x2: 75.2591,
    y2: 125.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2761_32788",
    x1: 76.9314,
    y1: 128.467,
    x2: 75.2591,
    y2: 128.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2761_32788",
    x1: 70.3425,
    y1: 128.842,
    x2: 68.6703,
    y2: 129.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2761_32788",
    x1: 62.6551,
    y1: 124.959,
    x2: 57.2876,
    y2: 126.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2761_32788",
    x1: 58.6055,
    y1: 124.839,
    x2: 57.4104,
    y2: 125.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2761_32788",
    x1: 63.1944,
    y1: 124.839,
    x2: 61.9992,
    y2: 125.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2761_32788",
    x1: 63.1944,
    y1: 128.467,
    x2: 61.9992,
    y2: 128.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2761_32788",
    x1: 58.6055,
    y1: 128.842,
    x2: 57.4104,
    y2: 129.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2761_32788",
    x1: 49.1939,
    y1: 124.959,
    x2: 43.437,
    y2: 127.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2761_32788",
    x1: 44.7681,
    y1: 124.839,
    x2: 43.4677,
    y2: 125.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2761_32788",
    x1: 49.7837,
    y1: 124.839,
    x2: 48.4833,
    y2: 125.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2761_32788",
    x1: 49.7837,
    y1: 128.467,
    x2: 48.4833,
    y2: 128.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2761_32788",
    x1: 44.7681,
    y1: 128.842,
    x2: 43.4677,
    y2: 129.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2761_32788",
    x1: 52.7363,
    y1: 125.262,
    x2: 50.0423,
    y2: 125.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2761_32788",
    x1: 56.0307,
    y1: 125.262,
    x2: 53.3367,
    y2: 125.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2761_32788",
    x1: 42.3051,
    y1: 125.262,
    x2: 39.6111,
    y2: 125.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2761_32788",
    x1: 66.7075,
    y1: 125.262,
    x2: 64.0135,
    y2: 125.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2761_32788",
    x1: 63.335,
    y1: 101.459,
    x2: 60.8534,
    y2: 105.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2761_32788",
    x1: 66.0177,
    y1: 102.848,
    x2: 64.3304,
    y2: 107.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2761_32788",
    x1: 67.8057,
    y1: 104.56,
    x2: 66.4562,
    y2: 109.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2761_32788",
    x1: 69.2949,
    y1: 105.953,
    x2: 68.1444,
    y2: 111.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2761_32788",
    x1: 70.6649,
    y1: 107.478,
    x2: 69.6539,
    y2: 112.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2761_32788",
    x1: 60.8317,
    y1: 98.583,
    x2: 59.4732,
    y2: 99.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2761_32788",
    x1: 61.031,
    y1: 99.5225,
    x2: 60.1322,
    y2: 100.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2761_32788",
    x1: 60.8987,
    y1: 100.008,
    x2: 60.4261,
    y2: 100.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2761_32788",
    x1: 61.5531,
    y1: 100.311,
    x2: 59.6824,
    y2: 102.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2761_32788",
    x1: 53.6646,
    y1: 107.744,
    x2: 51.7722,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2761_32788",
    x1: 53.9418,
    y1: 109.055,
    x2: 52.6897,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2761_32788",
    x1: 53.7583,
    y1: 109.728,
    x2: 53.1004,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2761_32788",
    x1: 57.4208,
    y1: 107.744,
    x2: 55.5285,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2761_32788",
    x1: 57.6978,
    y1: 109.055,
    x2: 56.4457,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2761_32788",
    x1: 57.5142,
    y1: 109.728,
    x2: 56.8562,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2761_32788",
    x1: 61.1773,
    y1: 107.744,
    x2: 59.2848,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2761_32788",
    x1: 61.4538,
    y1: 109.055,
    x2: 60.2016,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2761_32788",
    x1: 61.271,
    y1: 109.728,
    x2: 60.613,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2761_32788",
    x1: 61.1773,
    y1: 103.469,
    x2: 59.2848,
    y2: 104.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2761_32788",
    x1: 61.4538,
    y1: 104.779,
    x2: 60.2016,
    y2: 106.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2761_32788",
    x1: 61.271,
    y1: 105.452,
    x2: 60.613,
    y2: 106.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2761_32788",
    x1: 64.9335,
    y1: 107.744,
    x2: 63.0412,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2761_32788",
    x1: 65.2103,
    y1: 109.055,
    x2: 63.9582,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2761_32788",
    x1: 65.0269,
    y1: 109.728,
    x2: 64.3689,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2761_32788",
    x1: 68.6901,
    y1: 107.744,
    x2: 66.7976,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2761_32788",
    x1: 68.9673,
    y1: 109.055,
    x2: 67.7152,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2761_32788",
    x1: 68.7837,
    y1: 109.728,
    x2: 68.1257,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2761_32788",
    x1: 49.9351,
    y1: 101.459,
    x2: 47.4535,
    y2: 105.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2761_32788",
    x1: 52.6178,
    y1: 102.848,
    x2: 50.9305,
    y2: 107.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2761_32788",
    x1: 54.4058,
    y1: 104.56,
    x2: 53.0563,
    y2: 109.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2761_32788",
    x1: 55.895,
    y1: 105.953,
    x2: 54.7444,
    y2: 111.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2761_32788",
    x1: 57.2655,
    y1: 107.478,
    x2: 56.2545,
    y2: 112.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2761_32788",
    x1: 47.4316,
    y1: 98.583,
    x2: 46.0732,
    y2: 99.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2761_32788",
    x1: 47.6311,
    y1: 99.5225,
    x2: 46.7323,
    y2: 100.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2761_32788",
    x1: 47.4988,
    y1: 100.008,
    x2: 47.0262,
    y2: 100.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2761_32788",
    x1: 48.1532,
    y1: 100.311,
    x2: 46.2825,
    y2: 102.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2761_32788",
    x1: 40.2647,
    y1: 107.744,
    x2: 38.3723,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2761_32788",
    x1: 40.542,
    y1: 109.055,
    x2: 39.2899,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2761_32788",
    x1: 40.3584,
    y1: 109.728,
    x2: 39.7005,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2761_32788",
    x1: 44.0214,
    y1: 107.744,
    x2: 42.1291,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2761_32788",
    x1: 44.2981,
    y1: 109.055,
    x2: 43.0459,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2761_32788",
    x1: 44.1148,
    y1: 109.728,
    x2: 43.4568,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2761_32788",
    x1: 47.7774,
    y1: 107.744,
    x2: 45.8849,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2761_32788",
    x1: 48.0546,
    y1: 109.055,
    x2: 46.8024,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2761_32788",
    x1: 47.8711,
    y1: 109.728,
    x2: 47.2131,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2761_32788",
    x1: 47.7774,
    y1: 103.469,
    x2: 45.8849,
    y2: 104.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2761_32788",
    x1: 48.0546,
    y1: 104.779,
    x2: 46.8024,
    y2: 106.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2761_32788",
    x1: 47.8711,
    y1: 105.452,
    x2: 47.2131,
    y2: 106.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2761_32788",
    x1: 51.5336,
    y1: 107.744,
    x2: 49.6413,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2761_32788",
    x1: 51.8106,
    y1: 109.055,
    x2: 50.5585,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2761_32788",
    x1: 51.627,
    y1: 109.728,
    x2: 50.969,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_2761_32788",
    x1: 55.2899,
    y1: 107.744,
    x2: 53.3976,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_2761_32788",
    x1: 55.5673,
    y1: 109.055,
    x2: 54.3151,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_2761_32788",
    x1: 55.3838,
    y1: 109.728,
    x2: 54.7258,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_2761_32788",
    x1: 43.5448,
    y1: 106.032,
    x2: 37.0447,
    y2: 107.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_2761_32788",
    x1: 54.4055,
    y1: 106.026,
    x2: 47.1684,
    y2: 107.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_2761_32788",
    x1: 53.7783,
    y1: 115.046,
    x2: 52.1697,
    y2: 117.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_2761_32788",
    x1: 53.7317,
    y1: 116.352,
    x2: 52.0773,
    y2: 118.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_2761_32788",
    x1: 51.2027,
    y1: 106.032,
    x2: 39.8446,
    y2: 109.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_2761_32788",
    x1: 68.1897,
    y1: 106.032,
    x2: 61.6905,
    y2: 107.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_2761_32788",
    x1: 64.9893,
    y1: 106.032,
    x2: 53.6313,
    y2: 109.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_2761_32788",
    x1: 79.5102,
    y1: 106.032,
    x2: 63.607,
    y2: 113.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_2761_32788",
    x1: 41.8393,
    y1: 106.032,
    x2: 25.9361,
    y2: 113.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_2761_32788",
    x1: 57.697,
    y1: 106.026,
    x2: 51.1978,
    y2: 107.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_2761_32788",
    x1: 57.138,
    y1: 115.046,
    x2: 55.4545,
    y2: 117.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_2761_32788",
    x1: 57.0964,
    y1: 116.352,
    x2: 55.3763,
    y2: 118.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_2761_32788",
    x1: 56.8928,
    y1: 111.068,
    x2: 55.1461,
    y2: 113.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_2761_32788",
    x1: 87.1447,
    y1: 117.369,
    x2: 86.1284,
    y2: 126.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_2761_32788",
    x1: 83.6047,
    y1: 117.369,
    x2: 82.057,
    y2: 126.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_2761_32788",
    x1: 45.4967,
    y1: 115.135,
    x2: 44.9854,
    y2: 118.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_2761_32788",
    x1: 45.4967,
    y1: 116.607,
    x2: 44.9854,
    y2: 120.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_2761_32788",
    x1: 50.4117,
    y1: 115.047,
    x2: 49.335,
    y2: 118.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_2761_32788",
    x1: 50.325,
    y1: 116.346,
    x2: 49.1901,
    y2: 119.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_2761_32788",
    x1: 64.0265,
    y1: 115.047,
    x2: 62.9357,
    y2: 118.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_2761_32788",
    x1: 67.6283,
    y1: 115.047,
    x2: 65.9907,
    y2: 117.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_2761_32788",
    x1: 78.6637,
    y1: 115.047,
    x2: 77.9543,
    y2: 118.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_2761_32788",
    x1: 64.6046,
    y1: 116.346,
    x2: 63.5857,
    y2: 119.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_2761_32788",
    x1: 67.4343,
    y1: 116.346,
    x2: 65.6993,
    y2: 118.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_2761_32788",
    x1: 78.8064,
    y1: 116.346,
    x2: 78.0939,
    y2: 119.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_2761_32788",
    x1: 40.8571,
    y1: 111.147,
    x2: 40.1132,
    y2: 114.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_2761_32788",
    x1: 50.498,
    y1: 111.069,
    x2: 49.3903,
    y2: 114.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_2761_32788",
    x1: 42.8874,
    y1: 111.069,
    x2: 41.1407,
    y2: 113.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_2761_32788",
    x1: 53.2937,
    y1: 111.069,
    x2: 51.5469,
    y2: 113.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_2761_32788",
    x1: 67.3772,
    y1: 111.069,
    x2: 65.6304,
    y2: 113.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_2761_32788",
    x1: 64.5038,
    y1: 111.069,
    x2: 63.3962,
    y2: 114.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_2761_32788",
    x1: 78.2374,
    y1: 111.069,
    x2: 77.4598,
    y2: 114.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_2761_32788",
    x1: 106.126,
    y1: 144.747,
    x2: 152.027,
    y2: 105.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_2761_32788",
    x1: 141.064,
    y1: 121.864,
    x2: 143.384,
    y2: 114.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_2761_32788",
    x1: 161.395,
    y1: 121.797,
    x2: 134.832,
    y2: 131.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_2761_32788",
    x1: 152.937,
    y1: 120.518,
    x2: 150.915,
    y2: 120.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_2761_32788",
    x1: 149.308,
    y1: 136.292,
    x2: 146.173,
    y2: 137.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_2761_32788",
    x1: 127.278,
    y1: 121.864,
    x2: 129.598,
    y2: 114.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_2761_32788",
    x1: 147.609,
    y1: 121.797,
    x2: 121.046,
    y2: 131.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_2761_32788",
    x1: 139.151,
    y1: 120.518,
    x2: 137.129,
    y2: 120.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_2761_32788",
    x1: 135.522,
    y1: 136.292,
    x2: 132.386,
    y2: 137.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_2761_32788",
    x1: 143.114,
    y1: 140.227,
    x2: 142.408,
    y2: 143.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_2761_32788",
    x1: 158.002,
    y1: 141.35,
    x2: 157.356,
    y2: 144.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_2761_32788",
    x1: 164.978,
    y1: 135.456,
    x2: 164.808,
    y2: 139.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_2761_32788",
    x1: 164.978,
    y1: 134.167,
    x2: 164.808,
    y2: 137.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_2761_32788",
    x1: 164.978,
    y1: 132.883,
    x2: 164.808,
    y2: 136.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_2761_32788",
    x1: 128.631,
    y1: 120.084,
    x2: 126.609,
    y2: 120.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_2761_32788",
    x1: 118.737,
    y1: 129.965,
    x2: 125.714,
    y2: 126.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_2761_32788",
    x1: 124.551,
    y1: 126.964,
    x2: 126.223,
    y2: 126.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_2761_32788",
    x1: 117.962,
    y1: 126.964,
    x2: 119.634,
    y2: 126.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_2761_32788",
    x1: 117.962,
    y1: 130.592,
    x2: 119.634,
    y2: 130.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_2761_32788",
    x1: 124.551,
    y1: 130.967,
    x2: 126.223,
    y2: 130.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_2761_32788",
    x1: 132.239,
    y1: 129.965,
    x2: 137.606,
    y2: 128.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_2761_32788",
    x1: 136.288,
    y1: 126.964,
    x2: 137.483,
    y2: 126.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_2761_32788",
    x1: 131.7,
    y1: 126.964,
    x2: 132.895,
    y2: 126.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_2761_32788",
    x1: 131.7,
    y1: 130.592,
    x2: 132.895,
    y2: 130.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_2761_32788",
    x1: 136.288,
    y1: 130.967,
    x2: 137.483,
    y2: 130.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_2761_32788",
    x1: 145.699,
    y1: 129.965,
    x2: 151.456,
    y2: 127.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_2761_32788",
    x1: 150.126,
    y1: 126.964,
    x2: 151.426,
    y2: 126.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_2761_32788",
    x1: 145.11,
    y1: 126.964,
    x2: 146.41,
    y2: 126.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_2761_32788",
    x1: 145.11,
    y1: 130.592,
    x2: 146.41,
    y2: 130.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_2761_32788",
    x1: 150.126,
    y1: 130.967,
    x2: 151.426,
    y2: 130.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_2761_32788",
    x1: 142.157,
    y1: 129.902,
    x2: 144.851,
    y2: 129.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_2761_32788",
    x1: 138.863,
    y1: 129.902,
    x2: 141.557,
    y2: 129.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_2761_32788",
    x1: 152.589,
    y1: 129.902,
    x2: 155.283,
    y2: 129.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_2761_32788",
    x1: 128.186,
    y1: 129.902,
    x2: 130.88,
    y2: 129.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_2761_32788",
    x1: 131.558,
    y1: 102.968,
    x2: 134.04,
    y2: 99.1551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_2761_32788",
    x1: 128.876,
    y1: 104.351,
    x2: 130.563,
    y2: 99.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_2761_32788",
    x1: 127.088,
    y1: 106.063,
    x2: 128.438,
    y2: 100.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_2761_32788",
    x1: 125.599,
    y1: 107.467,
    x2: 126.749,
    y2: 102.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_2761_32788",
    x1: 124.228,
    y1: 108.986,
    x2: 125.239,
    y2: 103.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_2761_32788",
    x1: 135.307,
    y1: 98.583,
    x2: 133.948,
    y2: 99.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_2761_32788",
    x1: 135.505,
    y1: 99.5225,
    x2: 134.606,
    y2: 100.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_2761_32788",
    x1: 135.374,
    y1: 100.008,
    x2: 134.901,
    y2: 100.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_2761_32788",
    x1: 136.028,
    y1: 100.311,
    x2: 134.157,
    y2: 102.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_2761_32788",
    x1: 142.963,
    y1: 107.744,
    x2: 141.071,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_2761_32788",
    x1: 143.241,
    y1: 109.055,
    x2: 141.989,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_2761_32788",
    x1: 143.058,
    y1: 109.728,
    x2: 142.4,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_2761_32788",
    x1: 139.207,
    y1: 107.744,
    x2: 137.315,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_2761_32788",
    x1: 139.484,
    y1: 109.055,
    x2: 138.232,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_2761_32788",
    x1: 139.301,
    y1: 109.728,
    x2: 138.643,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_2761_32788",
    x1: 135.45,
    y1: 107.744,
    x2: 133.558,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_2761_32788",
    x1: 135.728,
    y1: 109.055,
    x2: 134.476,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_2761_32788",
    x1: 135.545,
    y1: 109.728,
    x2: 134.887,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_2761_32788",
    x1: 135.45,
    y1: 103.469,
    x2: 133.558,
    y2: 104.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_2761_32788",
    x1: 135.728,
    y1: 104.779,
    x2: 134.476,
    y2: 106.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_2761_32788",
    x1: 135.545,
    y1: 105.452,
    x2: 134.887,
    y2: 106.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_2761_32788",
    x1: 131.695,
    y1: 107.744,
    x2: 129.802,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_2761_32788",
    x1: 131.972,
    y1: 109.055,
    x2: 130.72,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_2761_32788",
    x1: 131.789,
    y1: 109.728,
    x2: 131.131,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_2761_32788",
    x1: 127.938,
    y1: 107.744,
    x2: 126.046,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_2761_32788",
    x1: 128.216,
    y1: 109.055,
    x2: 126.964,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_2761_32788",
    x1: 128.033,
    y1: 109.728,
    x2: 127.375,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_2761_32788",
    x1: 144.958,
    y1: 102.968,
    x2: 147.439,
    y2: 99.1551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_2761_32788",
    x1: 142.275,
    y1: 104.351,
    x2: 143.963,
    y2: 99.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_2761_32788",
    x1: 140.487,
    y1: 106.063,
    x2: 141.837,
    y2: 100.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_2761_32788",
    x1: 138.998,
    y1: 107.467,
    x2: 140.149,
    y2: 102.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_2761_32788",
    x1: 137.628,
    y1: 108.986,
    x2: 138.639,
    y2: 103.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_2761_32788",
    x1: 148.707,
    y1: 98.583,
    x2: 147.349,
    y2: 99.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_2761_32788",
    x1: 148.905,
    y1: 99.5225,
    x2: 148.006,
    y2: 100.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_2761_32788",
    x1: 148.774,
    y1: 100.008,
    x2: 148.301,
    y2: 100.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_2761_32788",
    x1: 149.428,
    y1: 100.311,
    x2: 147.557,
    y2: 102.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_2761_32788",
    x1: 156.362,
    y1: 107.744,
    x2: 154.47,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_2761_32788",
    x1: 156.64,
    y1: 109.055,
    x2: 155.388,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_2761_32788",
    x1: 156.457,
    y1: 109.728,
    x2: 155.799,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_2761_32788",
    x1: 152.606,
    y1: 107.744,
    x2: 150.714,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_2761_32788",
    x1: 152.884,
    y1: 109.055,
    x2: 151.632,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_2761_32788",
    x1: 152.701,
    y1: 109.728,
    x2: 152.043,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_2761_32788",
    x1: 148.849,
    y1: 107.744,
    x2: 146.957,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_2761_32788",
    x1: 149.128,
    y1: 109.055,
    x2: 147.876,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_2761_32788",
    x1: 148.945,
    y1: 109.728,
    x2: 148.287,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_2761_32788",
    x1: 148.849,
    y1: 103.469,
    x2: 146.957,
    y2: 104.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_2761_32788",
    x1: 149.128,
    y1: 104.779,
    x2: 147.876,
    y2: 106.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_2761_32788",
    x1: 148.945,
    y1: 105.452,
    x2: 148.287,
    y2: 106.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_2761_32788",
    x1: 145.094,
    y1: 107.744,
    x2: 143.201,
    y2: 108.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_2761_32788",
    x1: 145.371,
    y1: 109.055,
    x2: 144.119,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_2761_32788",
    x1: 145.188,
    y1: 109.728,
    x2: 144.53,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_2761_32788",
    x1: 141.337,
    y1: 107.744,
    x2: 139.444,
    y2: 108.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_2761_32788",
    x1: 141.615,
    y1: 109.055,
    x2: 140.363,
    y2: 110.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_2761_32788",
    x1: 141.432,
    y1: 109.728,
    x2: 140.774,
    y2: 110.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_2761_32788",
    x1: 156.294,
    y1: 106.032,
    x2: 149.795,
    y2: 107.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_2761_32788",
    x1: 146.029,
    y1: 106.026,
    x2: 138.793,
    y2: 107.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_2761_32788",
    x1: 145.437,
    y1: 115.046,
    x2: 143.828,
    y2: 117.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_2761_32788",
    x1: 145.204,
    y1: 116.352,
    x2: 143.55,
    y2: 118.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_2761_32788",
    x1: 152.85,
    y1: 106.032,
    x2: 141.492,
    y2: 109.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_2761_32788",
    x1: 131.649,
    y1: 106.032,
    x2: 125.149,
    y2: 107.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_2761_32788",
    x1: 139.062,
    y1: 106.032,
    x2: 127.705,
    y2: 109.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_2761_32788",
    x1: 129.67,
    y1: 106.032,
    x2: 113.768,
    y2: 113.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_2761_32788",
    x1: 167.341,
    y1: 106.032,
    x2: 151.438,
    y2: 113.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_2761_32788",
    x1: 142.142,
    y1: 106.026,
    x2: 135.642,
    y2: 107.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_2761_32788",
    x1: 141.613,
    y1: 115.046,
    x2: 139.93,
    y2: 117.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_2761_32788",
    x1: 141.406,
    y1: 116.352,
    x2: 139.686,
    y2: 118.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_2761_32788",
    x1: 141.408,
    y1: 111.068,
    x2: 139.661,
    y2: 113.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_2761_32788",
    x1: 167.522,
    y1: 117.369,
    x2: 166.506,
    y2: 126.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_2761_32788",
    x1: 149.858,
    y1: 117.369,
    x2: 148.31,
    y2: 126.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_2761_32788",
    x1: 167.796,
    y1: 115.135,
    x2: 167.285,
    y2: 118.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_2761_32788",
    x1: 167.796,
    y1: 116.607,
    x2: 167.285,
    y2: 120.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_2761_32788",
    x1: 152.516,
    y1: 115.047,
    x2: 151.439,
    y2: 118.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_2761_32788",
    x1: 152.084,
    y1: 116.346,
    x2: 150.949,
    y2: 119.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_2761_32788",
    x1: 138.771,
    y1: 115.047,
    x2: 137.681,
    y2: 118.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_2761_32788",
    x1: 131.411,
    y1: 115.047,
    x2: 129.774,
    y2: 117.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_2761_32788",
    x1: 129.22,
    y1: 115.047,
    x2: 128.51,
    y2: 118.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_2761_32788",
    x1: 138.887,
    y1: 116.346,
    x2: 137.868,
    y2: 119.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_2761_32788",
    x1: 130.958,
    y1: 116.346,
    x2: 129.223,
    y2: 118.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_2761_32788",
    x1: 129.017,
    y1: 116.346,
    x2: 128.305,
    y2: 119.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_2761_32788",
    x1: 166.37,
    y1: 111.147,
    x2: 165.626,
    y2: 114.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_2761_32788",
    x1: 152.148,
    y1: 111.069,
    x2: 151.04,
    y2: 114.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_2761_32788",
    x1: 155.412,
    y1: 111.069,
    x2: 153.666,
    y2: 113.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_2761_32788",
    x1: 145.006,
    y1: 111.069,
    x2: 143.259,
    y2: 113.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_2761_32788",
    x1: 130.923,
    y1: 111.069,
    x2: 129.176,
    y2: 113.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_2761_32788",
    x1: 138.143,
    y1: 111.069,
    x2: 137.035,
    y2: 114.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_2761_32788",
    x1: 128.403,
    y1: 111.069,
    x2: 127.625,
    y2: 114.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_2761_32788",
    x1: 199.881,
    y1: 99.0947,
    x2: 199.736,
    y2: 105.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_2761_32788",
    x1: 199.881,
    y1: 99.0947,
    x2: 199.736,
    y2: 105.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_2761_32788",
    x1: 199.881,
    y1: 96.7881,
    x2: 199.633,
    y2: 105.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_2761_32788",
    x1: 123.637,
    y1: 58.6152,
    x2: 95.8006,
    y2: 93.0462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_2761_32788",
    x1: 115.585,
    y1: 58.6152,
    x2: 87.4582,
    y2: 82.6842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_2761_32788",
    x1: 106.586,
    y1: 58.6152,
    x2: 85.9305,
    y2: 67.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_2761_32788",
    x1: 123.527,
    y1: 74.4365,
    x2: 119.798,
    y2: 90.1857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_2761_32788",
    x1: 123.516,
    y1: 71.2422,
    x2: 122.053,
    y2: 81.2646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_2761_32788",
    x1: 123.527,
    y1: 78.7061,
    x2: 122.067,
    y2: 88.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_2761_32788",
    x1: 126.275,
    y1: 83.9941,
    x2: 110.097,
    y2: 115.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_2761_32788",
    x1: 126.275,
    y1: 83.9941,
    x2: 126.004,
    y2: 88.5684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_2761_32788",
    x1: 126.275,
    y1: 83.9941,
    x2: 126.004,
    y2: 88.5684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_2761_32788",
    x1: 126.275,
    y1: 81.123,
    x2: 124.949,
    y2: 91.1822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_2761_32788",
    x1: 86.7672,
    y1: 69.3418,
    x2: 82.1295,
    y2: 70.8307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_2761_32788",
    x1: 111.118,
    y1: 69.3418,
    x2: 106.481,
    y2: 70.8307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_2761_32788",
    x1: 99.6617,
    y1: 47.7002,
    x2: 94.1228,
    y2: 50.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_2761_32788",
    x1: 100.473,
    y1: 51.5371,
    x2: 96.81,
    y2: 55.9679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_2761_32788",
    x1: 99.9369,
    y1: 53.5049,
    x2: 98.0101,
    y2: 56.8048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_2761_32788",
    x1: 102.604,
    y1: 54.7363,
    x2: 94.9796,
    y2: 62.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_2761_32788",
    x1: 98.3424,
    y1: 58.9746,
    x2: 96.3223,
    y2: 59.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_2761_32788",
    x1: 123.637,
    y1: 78.6592,
    x2: 95.8001,
    y2: 113.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_2761_32788",
    x1: 115.584,
    y1: 78.6592,
    x2: 87.4577,
    y2: 102.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_2761_32788",
    x1: 106.585,
    y1: 78.6592,
    x2: 85.93,
    y2: 87.5367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_2761_32788",
    x1: 123.515,
    y1: 91.2861,
    x2: 122.053,
    y2: 101.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_2761_32788",
    x1: 86.7667,
    y1: 89.3916,
    x2: 82.129,
    y2: 90.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_2761_32788",
    x1: 111.118,
    y1: 89.3916,
    x2: 106.48,
    y2: 90.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_2761_32788",
    x1: 99.6612,
    y1: 67.75,
    x2: 94.1224,
    y2: 70.4318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_2761_32788",
    x1: 100.473,
    y1: 71.5869,
    x2: 96.8095,
    y2: 76.0177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_2761_32788",
    x1: 99.9364,
    y1: 73.5547,
    x2: 98.0096,
    y2: 76.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_2761_32788",
    x1: 102.604,
    y1: 74.7861,
    x2: 94.9791,
    y2: 82.1658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_2761_32788",
    x1: 98.342,
    y1: 79.0303,
    x2: 96.3218,
    y2: 79.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_2761_32788",
    x1: 130.378,
    y1: 95.0654,
    x2: 128.773,
    y2: 106.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_2761_32788",
    x1: 130.378,
    y1: 98.416,
    x2: 64.8138,
    y2: 137.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_2761_32788",
    x1: 116.089,
    y1: 98.416,
    x2: 96.7775,
    y2: 122.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_2761_32788",
    x1: 130.378,
    y1: 98.416,
    x2: 130.113,
    y2: 103.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_2761_32788",
    x1: 130.378,
    y1: 98.416,
    x2: 130.113,
    y2: 103.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_2761_32788",
    x1: 110.574,
    y1: 101.866,
    x2: 108.282,
    y2: 105.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_2761_32788",
    x1: 113.053,
    y1: 103.146,
    x2: 111.495,
    y2: 107.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_2761_32788",
    x1: 114.705,
    y1: 104.731,
    x2: 113.458,
    y2: 109.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_2761_32788",
    x1: 116.081,
    y1: 106.026,
    x2: 115.018,
    y2: 110.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_2761_32788",
    x1: 117.347,
    y1: 107.426,
    x2: 116.414,
    y2: 112.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_2761_32788",
    x1: 126.221,
    y1: 109.994,
    x2: 125.63,
    y2: 116.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_2761_32788",
    x1: 126.221,
    y1: 111.873,
    x2: 125.63,
    y2: 118.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_2761_32788",
    x1: 126.221,
    y1: 113.763,
    x2: 125.63,
    y2: 120.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_2761_32788",
    x1: 126.221,
    y1: 115.646,
    x2: 125.63,
    y2: 122.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_2761_32788",
    x1: 108.26,
    y1: 99.2041,
    x2: 107.004,
    y2: 99.8122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_2761_32788",
    x1: 108.443,
    y1: 100.07,
    x2: 107.613,
    y2: 101.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_2761_32788",
    x1: 108.323,
    y1: 100.515,
    x2: 107.887,
    y2: 101.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_2761_32788",
    x1: 108.928,
    y1: 100.796,
    x2: 107.199,
    y2: 102.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_2761_32788",
    x1: 101.638,
    y1: 107.666,
    x2: 99.8889,
    y2: 108.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_2761_32788",
    x1: 101.894,
    y1: 108.872,
    x2: 100.737,
    y2: 110.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_2761_32788",
    x1: 101.724,
    y1: 109.498,
    x2: 101.116,
    y2: 110.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_2761_32788",
    x1: 105.109,
    y1: 107.666,
    x2: 103.359,
    y2: 108.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_2761_32788",
    x1: 105.365,
    y1: 108.872,
    x2: 104.208,
    y2: 110.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_2761_32788",
    x1: 105.196,
    y1: 109.498,
    x2: 104.588,
    y2: 110.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_2761_32788",
    x1: 108.579,
    y1: 107.666,
    x2: 106.83,
    y2: 108.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_2761_32788",
    x1: 108.835,
    y1: 108.872,
    x2: 107.678,
    y2: 110.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_2761_32788",
    x1: 108.666,
    y1: 109.498,
    x2: 108.058,
    y2: 110.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_2761_32788",
    x1: 108.579,
    y1: 103.725,
    x2: 106.83,
    y2: 104.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_2761_32788",
    x1: 108.835,
    y1: 104.931,
    x2: 107.678,
    y2: 106.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_2761_32788",
    x1: 108.666,
    y1: 105.557,
    x2: 108.058,
    y2: 106.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_2761_32788",
    x1: 112.051,
    y1: 107.666,
    x2: 110.301,
    y2: 108.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_2761_32788",
    x1: 112.307,
    y1: 108.872,
    x2: 111.15,
    y2: 110.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_2761_32788",
    x1: 112.137,
    y1: 109.498,
    x2: 111.529,
    y2: 110.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_2761_32788",
    x1: 115.522,
    y1: 107.666,
    x2: 113.772,
    y2: 108.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_2761_32788",
    x1: 115.778,
    y1: 108.872,
    x2: 114.621,
    y2: 110.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_2761_32788",
    x1: 115.608,
    y1: 109.498,
    x2: 115,
    y2: 110.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_2761_32788",
    x1: 87.6101,
    y1: 101.861,
    x2: 85.3178,
    y2: 105.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_2761_32788",
    x1: 90.0883,
    y1: 103.146,
    x2: 88.5298,
    y2: 107.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_2761_32788",
    x1: 91.7398,
    y1: 104.731,
    x2: 90.4932,
    y2: 109.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_2761_32788",
    x1: 93.1166,
    y1: 106.021,
    x2: 92.0539,
    y2: 110.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_2761_32788",
    x1: 94.3831,
    y1: 107.426,
    x2: 93.4493,
    y2: 112.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_2761_32788",
    x1: 85.2958,
    y1: 99.2041,
    x2: 84.0398,
    y2: 99.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_2761_32788",
    x1: 85.4787,
    y1: 100.07,
    x2: 84.6488,
    y2: 101.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_2761_32788",
    x1: 85.3583,
    y1: 100.515,
    x2: 84.9221,
    y2: 101.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_2761_32788",
    x1: 85.9631,
    y1: 100.796,
    x2: 84.2344,
    y2: 102.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_2761_32788",
    x1: 78.6732,
    y1: 107.665,
    x2: 76.9236,
    y2: 108.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_2761_32788",
    x1: 78.9289,
    y1: 108.871,
    x2: 77.7719,
    y2: 110.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_2761_32788",
    x1: 78.7596,
    y1: 109.497,
    x2: 78.1517,
    y2: 110.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_2761_32788",
    x1: 82.1443,
    y1: 107.665,
    x2: 80.3948,
    y2: 108.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_2761_32788",
    x1: 82.4001,
    y1: 108.871,
    x2: 81.2431,
    y2: 110.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_2761_32788",
    x1: 82.2308,
    y1: 109.497,
    x2: 81.6228,
    y2: 110.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_2761_32788",
    x1: 85.6148,
    y1: 107.665,
    x2: 83.8651,
    y2: 108.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_2761_32788",
    x1: 85.871,
    y1: 108.871,
    x2: 84.714,
    y2: 110.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_2761_32788",
    x1: 85.7015,
    y1: 109.497,
    x2: 85.0936,
    y2: 110.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_2761_32788",
    x1: 85.6148,
    y1: 103.72,
    x2: 83.8651,
    y2: 104.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_2761_32788",
    x1: 85.871,
    y1: 104.926,
    x2: 84.714,
    y2: 106.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_2761_32788",
    x1: 85.7015,
    y1: 105.552,
    x2: 85.0934,
    y2: 106.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_2761_32788",
    x1: 89.086,
    y1: 107.665,
    x2: 87.3367,
    y2: 108.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_2761_32788",
    x1: 89.342,
    y1: 108.871,
    x2: 88.185,
    y2: 110.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_2761_32788",
    x1: 89.1722,
    y1: 109.497,
    x2: 88.5643,
    y2: 110.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_2761_32788",
    x1: 92.5567,
    y1: 107.665,
    x2: 90.807,
    y2: 108.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_2761_32788",
    x1: 92.8129,
    y1: 108.871,
    x2: 91.6559,
    y2: 110.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_2761_32788",
    x1: 92.6434,
    y1: 109.497,
    x2: 92.0354,
    y2: 110.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_2761_32788",
    x1: 130.654,
    y1: 117.489,
    x2: 129.931,
    y2: 125.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_2761_32788",
    x1: 130.517,
    y1: 119.697,
    x2: 130.395,
    y2: 123.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_2761_32788",
    x1: 84.1256,
    y1: 120.657,
    x2: 71.5959,
    y2: 123.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_2761_32788",
    x1: 84.1256,
    y1: 120.657,
    x2: 82.3434,
    y2: 125.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_2761_32788",
    x1: 84.1256,
    y1: 120.657,
    x2: 82.3434,
    y2: 125.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_2761_32788",
    x1: 83.6214,
    y1: 139.673,
    x2: 78.7606,
    y2: 145.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_2761_32788",
    x1: 83.1013,
    y1: 137.121,
    x2: 78.1912,
    y2: 142.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_2761_32788",
    x1: 85.0079,
    y1: 142.236,
    x2: 82.3976,
    y2: 147.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_2761_32788",
    x1: 119.493,
    y1: 120.657,
    x2: 106.963,
    y2: 123.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint516_linear_2761_32788",
    x1: 119.493,
    y1: 120.657,
    x2: 117.711,
    y2: 125.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint517_linear_2761_32788",
    x1: 119.493,
    y1: 120.657,
    x2: 117.711,
    y2: 125.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint518_linear_2761_32788",
    x1: 118.988,
    y1: 139.673,
    x2: 114.127,
    y2: 145.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint519_linear_2761_32788",
    x1: 118.469,
    y1: 137.121,
    x2: 113.559,
    y2: 142.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint520_linear_2761_32788",
    x1: 120.374,
    y1: 142.236,
    x2: 117.764,
    y2: 147.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint521_linear_2761_32788",
    x1: 234.455,
    y1: 143.954,
    x2: 227.186,
    y2: 195.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint522_linear_2761_32788",
    x1: 182.073,
    y1: 143.954,
    x2: 170.68,
    y2: 193.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint523_linear_2761_32788",
    x1: 125.067,
    y1: 138.698,
    x2: 120.338,
    y2: 157.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint524_linear_2761_32788",
    x1: 122.726,
    y1: 138.943,
    x2: 122.541,
    y2: 142.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint525_linear_2761_32788",
    x1: 123.092,
    y1: 139.747,
    x2: 122.91,
    y2: 143.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint526_linear_2761_32788",
    x1: 123.459,
    y1: 140.562,
    x2: 123.279,
    y2: 144.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint527_linear_2761_32788",
    x1: 123.825,
    y1: 141.376,
    x2: 123.648,
    y2: 144.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint528_linear_2761_32788",
    x1: 124.191,
    y1: 142.185,
    x2: 124.016,
    y2: 145.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint529_linear_2761_32788",
    x1: 124.557,
    y1: 142.989,
    x2: 124.384,
    y2: 146.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint530_linear_2761_32788",
    x1: 99.8507,
    y1: 99.4658,
    x2: 97.4275,
    y2: 103.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint531_linear_2761_32788",
    x1: 102.471,
    y1: 100.813,
    x2: 100.823,
    y2: 105.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint532_linear_2761_32788",
    x1: 104.217,
    y1: 102.488,
    x2: 102.899,
    y2: 107.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint533_linear_2761_32788",
    x1: 105.671,
    y1: 103.855,
    x2: 104.547,
    y2: 108.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint534_linear_2761_32788",
    x1: 107.009,
    y1: 105.338,
    x2: 106.021,
    y2: 110.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint535_linear_2761_32788",
    x1: 110.615,
    y1: 108.053,
    x2: 109.25,
    y2: 115.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint536_linear_2761_32788",
    x1: 110.615,
    y1: 110.041,
    x2: 109.25,
    y2: 117.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint537_linear_2761_32788",
    x1: 110.615,
    y1: 112.035,
    x2: 109.25,
    y2: 119.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint538_linear_2761_32788",
    x1: 110.615,
    y1: 114.024,
    x2: 109.25,
    y2: 121.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint539_linear_2761_32788",
    x1: 97.4055,
    y1: 96.6523,
    x2: 96.0787,
    y2: 97.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint540_linear_2761_32788",
    x1: 97.5999,
    y1: 97.5713,
    x2: 96.723,
    y2: 98.6326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint541_linear_2761_32788",
    x1: 97.4715,
    y1: 98.0459,
    x2: 97.0103,
    y2: 98.8362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint542_linear_2761_32788",
    x1: 98.1099,
    y1: 98.3379,
    x2: 96.2844,
    y2: 100.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint543_linear_2761_32788",
    x1: 90.4058,
    y1: 105.6,
    x2: 88.5566,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint544_linear_2761_32788",
    x1: 90.6772,
    y1: 106.879,
    x2: 89.4551,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint545_linear_2761_32788",
    x1: 90.4971,
    y1: 107.536,
    x2: 89.8543,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint546_linear_2761_32788",
    x1: 94.0742,
    y1: 105.6,
    x2: 92.225,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint547_linear_2761_32788",
    x1: 94.344,
    y1: 106.879,
    x2: 93.1218,
    y2: 108.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint548_linear_2761_32788",
    x1: 94.1655,
    y1: 107.536,
    x2: 93.5228,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint549_linear_2761_32788",
    x1: 97.7427,
    y1: 105.6,
    x2: 95.8935,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint550_linear_2761_32788",
    x1: 98.0136,
    y1: 106.879,
    x2: 96.7915,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint551_linear_2761_32788",
    x1: 97.834,
    y1: 107.536,
    x2: 97.1912,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint552_linear_2761_32788",
    x1: 97.7427,
    y1: 101.424,
    x2: 95.8935,
    y2: 102.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint553_linear_2761_32788",
    x1: 98.0136,
    y1: 102.703,
    x2: 96.7915,
    y2: 104.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint554_linear_2761_32788",
    x1: 97.834,
    y1: 103.36,
    x2: 97.1912,
    y2: 104.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint555_linear_2761_32788",
    x1: 101.411,
    y1: 105.6,
    x2: 99.5619,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint556_linear_2761_32788",
    x1: 101.681,
    y1: 106.879,
    x2: 100.459,
    y2: 108.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint557_linear_2761_32788",
    x1: 101.502,
    y1: 107.536,
    x2: 100.86,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint558_linear_2761_32788",
    x1: 105.08,
    y1: 105.6,
    x2: 103.23,
    y2: 106.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint559_linear_2761_32788",
    x1: 105.351,
    y1: 106.879,
    x2: 104.129,
    y2: 108.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint560_linear_2761_32788",
    x1: 105.171,
    y1: 107.536,
    x2: 104.528,
    y2: 108.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint561_linear_2761_32788",
    x1: 115.283,
    y1: 115.971,
    x2: 113.827,
    y2: 124.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint562_linear_2761_32788",
    x1: 115.084,
    y1: 118.305,
    x2: 114.83,
    y2: 121.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint563_linear_2761_32788",
    x1: 95.0978,
    y1: 119.396,
    x2: 81.6107,
    y2: 122.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint564_linear_2761_32788",
    x1: 95.0978,
    y1: 119.396,
    x2: 94.0219,
    y2: 123.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint565_linear_2761_32788",
    x1: 95.0978,
    y1: 119.396,
    x2: 94.0219,
    y2: 123.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint566_linear_2761_32788",
    x1: 94.469,
    y1: 139.424,
    x2: 89.3315,
    y2: 145.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint567_linear_2761_32788",
    x1: 93.9193,
    y1: 136.72,
    x2: 88.7298,
    y2: 141.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint568_linear_2761_32788",
    x1: 95.9341,
    y1: 142.123,
    x2: 93.1748,
    y2: 148.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint569_linear_2761_32788",
    x1: 109.372,
    y1: 119.396,
    x2: 95.8852,
    y2: 122.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint570_linear_2761_32788",
    x1: 109.372,
    y1: 119.396,
    x2: 108.296,
    y2: 123.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint571_linear_2761_32788",
    x1: 109.372,
    y1: 119.396,
    x2: 108.296,
    y2: 123.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint572_linear_2761_32788",
    x1: 108.743,
    y1: 139.43,
    x2: 103.606,
    y2: 145.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint573_linear_2761_32788",
    x1: 108.194,
    y1: 136.726,
    x2: 103.004,
    y2: 141.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint574_linear_2761_32788",
    x1: 110.209,
    y1: 142.128,
    x2: 107.449,
    y2: 148.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint575_linear_2761_32788",
    x1: 137.981,
    y1: 144.398,
    x2: 137.864,
    y2: 147.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint576_linear_2761_32788",
    x1: 138.015,
    y1: 145.155,
    x2: 137.898,
    y2: 148.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint577_linear_2761_32788",
    x1: 138.05,
    y1: 145.907,
    x2: 137.933,
    y2: 149.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint578_linear_2761_32788",
    x1: 138.084,
    y1: 146.664,
    x2: 137.967,
    y2: 150.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint579_linear_2761_32788",
    x1: 138.119,
    y1: 147.421,
    x2: 138.002,
    y2: 151.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint580_linear_2761_32788",
    x1: 138.153,
    y1: 148.173,
    x2: 138.037,
    y2: 151.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint581_linear_2761_32788",
    x1: 138.17,
    y1: 148.548,
    x2: 138.054,
    y2: 152.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint582_linear_2761_32788",
    x1: 73.43,
    y1: 143.954,
    x2: 66.2493,
    y2: 148.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint583_linear_2761_32788",
    x1: 127.14,
    y1: 143.954,
    x2: 119.959,
    y2: 148.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint584_linear_2761_32788",
    x1: 145.942,
    y1: 148.303,
    x2: 136.605,
    y2: 182.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint585_linear_2761_32788",
    x1: 146.67,
    y1: 148.684,
    x2: 146.574,
    y2: 152.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint586_linear_2761_32788",
    x1: 146.698,
    y1: 149.853,
    x2: 146.602,
    y2: 153.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint587_linear_2761_32788",
    x1: 146.728,
    y1: 151.027,
    x2: 146.631,
    y2: 154.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint588_linear_2761_32788",
    x1: 146.756,
    y1: 152.191,
    x2: 146.66,
    y2: 155.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint589_linear_2761_32788",
    x1: 146.785,
    y1: 153.355,
    x2: 146.688,
    y2: 156.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint590_linear_2761_32788",
    x1: 146.813,
    y1: 154.53,
    x2: 146.717,
    y2: 158.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint591_linear_2761_32788",
    x1: 146.842,
    y1: 155.699,
    x2: 146.746,
    y2: 159.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint592_linear_2761_32788",
    x1: 146.87,
    y1: 156.868,
    x2: 146.774,
    y2: 160.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint593_linear_2761_32788",
    x1: 146.899,
    y1: 158.032,
    x2: 146.803,
    y2: 161.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint594_linear_2761_32788",
    x1: 65.4957,
    y1: 148.428,
    x2: 58.0487,
    y2: 150.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint595_linear_2761_32788",
    x1: 65.8689,
    y1: 150.933,
    x2: 65.1115,
    y2: 153.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint596_linear_2761_32788",
    x1: 65.8689,
    y1: 148.177,
    x2: 65.1115,
    y2: 150.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint597_linear_2761_32788",
    x1: 65.8687,
    y1: 153.303,
    x2: 65.3285,
    y2: 155.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint598_linear_2761_32788",
    x1: 134.31,
    y1: 148.428,
    x2: 126.863,
    y2: 150.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint599_linear_2761_32788",
    x1: 134.683,
    y1: 150.933,
    x2: 133.926,
    y2: 153.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint600_linear_2761_32788",
    x1: 134.683,
    y1: 148.177,
    x2: 133.926,
    y2: 150.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint601_linear_2761_32788",
    x1: 134.683,
    y1: 153.303,
    x2: 134.143,
    y2: 155.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2761_32788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 166,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulturalSites);
export default __webpack_public_path__ + "static/media/Cultural Sites.eff6d9e93d42062ec35fa7798cf0ad2d.svg";
export { ForwardRef as ReactComponent };